// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from scripts/convert-letter-svgs.js
// Source: src/assets/images/letters/

import { getBrandColor } from '../../../utils/helpers';

const LetterIcons = {
  letter0to9: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letter0-9-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letter0-9-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letter0-9-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="72"
        x="4"
        y="-1"
      >
        <path d="m4-1h72v82h-72z" fill="#fff" />
        <path
          d="m41.2017 79 12.767-77.81818h12.1591l-12.767 77.81818zm-34.84343-19.3026 2.01384-12.159h60.79549l-2.0139 12.159zm7.48543 19.3026 12.7671-77.81818h12.159l-12.767 77.81818zm-3.0398-46.3565 2.0519-12.1591h60.7954l-2.0518 12.1591z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letter0-9-a)">
        <path
          d="m41.2017 79 12.767-77.81818h12.1591l-12.767 77.81818zm-34.84343-19.3026 2.01384-12.159h60.79549l-2.0139 12.159zm7.48543 19.3026 12.7671-77.81818h12.159l-12.767 77.81818zm-3.0398-46.3565 2.0519-12.1591h60.7954l-2.0518 12.1591z"
          fill={getBrandColor()}
        />
        <path
          d="m41.2017 79-1.4802-.2428-.286 1.7428h1.7662zm12.767-77.81818v-1.500004h-1.274l-.2062 1.257153zm12.1591 0 1.4802.24284.2859-1.742844h-1.7661zm-12.767 77.81818v1.5h1.2739l.2063-1.2572zm-47.00253-19.3026-1.47984-.2451-.28904 1.7451h1.76888zm2.01384-12.159v-1.5h-1.27199l-.20785 1.2549zm60.79549 0 1.4798.2451.289-1.7451h-1.7688zm-2.0139 12.159v1.5h1.272l.2079-1.2549zm-53.31 19.3026-1.4802-.2428-.2859 1.7428h1.7661zm12.7671-77.81818v-1.500004h-1.274l-.2063 1.257153zm12.159 0 1.4803.24284.2859-1.742844h-1.7662zm-12.767 77.81818v1.5h1.274l.2062-1.2572zm-15.1989-46.3565-1.47906-.2496-.29524 1.7496h1.7743zm2.0519-12.1591v-1.5h-1.2681l-.211 1.2504zm60.7954 0 1.4791.2496.2953-1.7496h-1.7744zm-2.0518 12.1591v1.5h1.2681l.211-1.2504zm-28.9175 46.5993 12.767-77.81814-2.9604-.485691-12.767 77.818231zm11.2868-76.56098h12.1591v-3.000004h-12.1591zm10.6789-1.742851-12.7671 77.818231 2.9605.4856 12.767-77.81814zm-11.2868 76.561031h-12.1591v3h12.1591zm-45.52269-17.5575 2.01384-12.159-2.95968-.4902-2.01384 12.159zm.534-10.9041h60.79549v-3h-60.79549zm59.31559-1.7451-2.0138 12.159 2.9597.4902 2.0138-12.159zm-.534 10.9041h-60.79543v3h60.79543zm-51.8298 21.0454 12.7671-77.81814-2.9605-.485691-12.767 77.818231zm11.2869-76.56098h12.159v-3.000004h-12.159zm10.6788-1.742851-12.767 77.818231 2.9604.4856 12.7671-77.81814zm-11.2868 76.561031h-12.1591v3h12.1591zm-13.7198-44.6069 2.0519-12.1591-2.9582-.4992-2.05186 12.1591zm.5728-10.9087h60.7954v-3h-60.7954zm59.3163-1.7496-2.0518 12.1591 2.9582.4992 2.0518-12.1591zm-.5727 10.9087h-60.7955v3h60.7955z"
          fill="#000"
          mask="url(#letter0-9-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letter0-9-b)"
      />
    </svg>
  ),

  letterA: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterA-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterA-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <g clipPath="url(#letterA-a)">
        <path
          clipRule="evenodd"
          d="m19.0216 79.5919 5.996-18.3674h29.1528l5.996 18.3674h18.815l-27.9123-79.387798h-22.7434l-27.705583 79.387798zm10.3379-31.4287h20.6758l-9.7176-30.4081h-1.0338z"
          fill={getBrandColor()}
          fillRule="evenodd"
        />
        <path
          d="m25.0176 61.2245v-.75h-.5442l-.1688.5173zm-5.996 18.3674v.75h.5441l.1688-.5173zm35.1488-18.3674.713-.2327-.1689-.5173h-.5441zm5.996 18.3674-.713.2327.1689.5173h.5441zm18.815 0v.75h1.0587l-.3512-.9988zm-27.9123-79.387798.7075-.2487682-.1762-.5012318h-.5313zm-22.7434 0v-.75h-.5326l-.1755.5028738zm-27.705583 79.387798-.7081162-.2471-.3479868.9971h1.056103zm49.415183-31.4287v.75h1.0271l-.3127-.9783zm-20.6758 0-.713-.2327-.3207.9827h1.0337zm10.9582-30.4081.7144-.2283-.1667-.5217h-.5477zm-1.0338 0v-.75h-.5442l-.1688.5173zm-14.9793 43.2367-5.996 18.3674 1.4259.4654 5.996-18.3673zm29.8658-.5173h-29.1528v1.5h29.1528zm6.709 18.8847-5.996-18.3674-1.4259.4655 5.9959 18.3673zm18.102-.5173h-18.815v1.5h18.815zm-28.6199-78.389031 27.9123 79.387831 1.4151-.4976-27.9123-79.3877662zm-22.0358.501233h22.7434v-1.5h-22.7434zm-26.99747 78.884898 27.70557-79.387773-1.4162-.4942512-27.7055992 79.3878242zm17.69337-.9971h-18.401483v1.5h18.401483zm31.0137-31.4287h-20.6758v1.5h20.6758zm-10.432-29.4298 9.7176 30.4082 1.4288-.4567-9.7176-30.4081zm-.3194.5217h1.0338v-1.5h-1.0338zm-9.2114 29.8908 9.9244-30.4081-1.426-.4654-9.9244 30.4081z"
          fill="#000"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterA-b)"
      />
    </svg>
  ),

  letterB: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterB-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterB-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterB-c"
        height="80"
        maskUnits="userSpaceOnUse"
        width="80"
        x="0"
        y="0"
      >
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterB-d"
        height="80"
        maskUnits="userSpaceOnUse"
        width="80"
        x="0"
        y="0"
      >
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <g clipPath="url(#letterB-a)">
        <g mask="url(#letterB-c)">
          <g mask="url(#letterB-d)">
            <path
              d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
              fill="#000"
            />
          </g>
          <path
            d="m9 80v-80h32.0313c5.8854 0 10.7942.872396 14.7265 2.61719 3.9323 1.74479 6.8881 4.16666 8.8672 7.26562 1.9792 3.07289 2.9688 6.61459 2.9688 10.62499 0 3.125-.625 5.8724-1.875 8.2422-1.25 2.3437-2.9688 4.2708-5.1563 5.7812-2.1614 1.4844-4.6354 2.5391-7.4218 3.1641v.7813c3.0468.1302 5.8984.9895 8.5546 2.5781 2.6823 1.5885 4.8568 3.8151 6.5235 6.6797 1.6666 2.8385 2.5 6.2239 2.5 10.1562 0 4.2448-1.0547 8.0339-3.1641 11.3672-2.0833 3.3073-5.1693 5.9245-9.2578 7.8516s-9.1276 2.8906-15.1172 2.8906zm16.9141-13.8281h13.7891c4.7135 0 8.151-.8985 10.3125-2.6953 2.1614-1.823 3.2421-4.2448 3.2421-7.2657 0-2.2135-.5338-4.1666-1.6015-5.8593s-2.5912-3.0209-4.5703-3.9844c-1.9532-.9636-4.2839-1.4453-6.9922-1.4453h-14.1797zm0-32.6953h12.539c2.3178 0 4.3751-.4037 6.1719-1.211 1.8229-.8333 3.2552-2.0052 4.2969-3.5156 1.0677-1.5104 1.6016-3.3203 1.6016-5.4297 0-2.8906-1.0287-5.2213-3.086-6.9922-2.0312-1.7708-4.9218-2.6562-8.6718-2.6562h-12.8516z"
            fill={getBrandColor()}
          />
          <path
            d="m8.75 80h-.75v.75h.75zm0-79.99999988v-.75000012h-.75v.75000012zm55.625 9.88280988-.6321.40369.0016.0024zm1.0938 18.86719.6617.3529.0017-.003zm-5.1563 5.7812.4246.6183.0016-.0011zm-7.4218 3.1641-.1642-.7318-.5858.1314v.6004zm0 .7813h-.75v.7186l.7179.0307zm8.5546 2.5781-.3849.6437.0028.0016zm6.5235 6.6797-.6483.3771.0015.0026zm-.6641 21.5234-.6338-.401-.0008.0013zm-41.6406-3.0859h-.75v.75h.75zm24.1016-2.6953.4794.5767.0041-.0034zm-2.9297-17.1094-.3319.6726.0036.0017zm-21.1719-1.4453v-.75h-.75v.75zm0-11.4453h-.75v.75h.75zm18.7109-1.211.3074.6842.0044-.0021zm4.2969-3.5156-.6125-.433-.0049.0072zm-1.4844-12.4219-.4928.5654.0035.003zm-21.5234-2.6562v-.75h-.75v.75zm-16.1641 66.3281v-79.99999988h-1.5v79.99999988zm-.75-79.25h32.0313v-1.5h-32.0313zm32.0313 0c5.8169 0 10.6142.86302 14.4224 2.55273l.6083-1.37109c-4.0564-1.799874-9.0768-2.68164-15.0307-2.68164zm14.4224 2.55273c3.821 1.69544 6.6521 4.02885 8.5392 6.98377l1.2642-.80738c-2.0711-3.243-5.1516-5.75334-9.1951-7.54748zm8.5408 6.98617c1.8937 2.9402 2.8493 6.338 2.8493 10.2189h1.5c0-4.1399-1.0236-7.8254-3.0882-11.0311zm2.8493 10.2189c0 3.0234-.6041 5.647-1.7884 7.8923l1.3268.6998c1.3156-2.4943 1.9616-5.3655 1.9616-8.5921zm-1.7868 7.8893c-1.1936 2.238-2.8315 4.0745-4.9206 5.517l.8523 1.2343c2.2859-1.5784 4.0855-3.596 5.3918-6.0455zm-4.9191 5.5159c-2.0759 1.4256-4.4598 2.4445-7.1614 3.0505l.3283 1.4636c2.8714-.644 5.4353-1.7345 7.6823-3.2776zm-7.7472 3.7823v.7813h1.5v-.7813zm.7179 1.5306c2.9204.1248 5.6509.9469 8.2018 2.4725l.7699-1.2874c-2.7616-1.6515-5.7342-2.5481-8.9076-2.6838zm8.2046 2.4741c2.5652 1.5192 4.6508 3.6504 6.2573 6.4115l1.2965-.7543c-1.7268-2.968-3.9901-5.2899-6.7895-6.9478zm6.2588 6.4141c1.587 2.7028 2.3968 5.9517 2.3968 9.7765h1.5c0-4.0397-.8569-7.5617-2.6033-10.536zm2.3968 9.7765c0 4.1141-1.0202 7.762-3.0479 10.9662l1.2676.8021c2.1911-3.4625 3.2803-7.3927 3.2803-11.7683zm-3.0487 10.9675c-1.9958 3.1683-4.9631 5.697-8.943 7.5729l.6396 1.3568c4.1972-1.9783 7.4017-4.684 9.5726-8.1302zm-8.943 7.5729c-3.9615 1.8672-8.8841 2.819-14.7974 2.819v1.5c6.0659 0 11.2214-.9753 15.437-2.9622zm-14.7974 2.819h-34.1797v1.5h34.1797zm-17.2656-12.3281h13.789v-1.5h-13.789zm13.789 0c4.7798 0 8.4308-.9057 10.792-2.8686l-.9589-1.1535c-1.9618 1.6309-5.1857 2.5221-9.8331 2.5221zm10.7961-2.872c2.3431-1.9762 3.5086-4.6143 3.5086-7.839h-1.5c0 2.817-.9959 5.0227-2.9757 6.6923zm3.5086-7.839c0-2.3396-.566-4.4345-1.7172-6.2595l-1.2687.8003c.9843 1.5604 1.4859 3.3718 1.4859 5.4592zm-1.7172-6.2595c-1.1495-1.8224-2.7846-3.2402-4.8763-4.2585l-.6566 1.3486c1.8666.9087 3.2784 2.1472 4.2642 3.7102zm-4.8728-4.2568c-2.0784-1.0253-4.528-1.5227-7.324-1.5227v1.5c2.6206 0 4.8325.4661 6.6603 1.3679zm-7.324-1.5227h-14.1797v1.5h14.1797zm-14.9297.75v21.25h1.5v-21.25zm.75-10.6953h12.539v-1.5h-12.539zm12.539 0c2.4052 0 4.5702-.419 6.4793-1.2768l-.6147-1.3683c-1.6847.7569-3.6343 1.1451-5.8646 1.1451zm6.4837-1.2789c1.9343-.8842 3.477-2.1399 4.6025-3.7719l-1.2348-.8516c-.9578 1.3888-2.2798 2.4769-3.9913 3.2593zm4.5975-3.7648c1.1695-1.6543 1.7392-3.6207 1.7392-5.8626h-1.5c0 1.9769-.4981 3.6301-1.4641 4.9967zm1.7392-5.8626c0-3.0929-1.112-5.6371-3.3467-7.5606l-.9786 1.1368c1.88 1.6182 2.8253 3.7355 2.8253 6.4238zm-3.3431-7.5575c-2.2131-1.9294-5.3043-2.8409-9.1647-2.8409v1.5c3.6395 0 6.3296.8592 8.179 2.4716zm-9.1647-2.8409h-12.8516v1.5h12.8516zm-13.6016.75v19.8047h1.5v-19.8047z"
            fill="#000"
          />
        </g>
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterB-b)"
      />
    </svg>
  ),

  letterC: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterC-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask
        id="letterC-b"
        height="80"
        maskUnits="userSpaceOnUse"
        width="80"
        x="0"
        y="0"
      >
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterC-c"
        height="80"
        maskUnits="userSpaceOnUse"
        width="80"
        x="0"
        y="0"
      >
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <g clipPath="url(#letterC-a)">
        <g mask="url(#letterC-b)">
          <g mask="url(#letterC-c)">
            <path
              d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
              fill="#000"
            />
          </g>
          <path
            d="m74.3095 28.8438h-16.1762c-.2954-2.0929-.8987-3.9518-1.8096-5.5768-.911-1.6496-2.0805-3.053-3.5086-4.2102-1.428-1.1572-3.0776-2.0435-4.9488-2.6591-1.8466-.6155-3.8532-.9233-6.0199-.9233-3.9148 0-7.3248.9726-10.2301 2.9176-2.9053 1.9205-5.1582 4.7273-6.7585 8.4205-1.6004 3.6686-2.4006 8.125-2.4006 13.3693 0 5.3921.8002 9.9224 2.4006 13.5909 1.625 3.6686 3.8901 6.4385 6.7954 8.3097s6.2661 2.8068 10.0824 2.8068c2.142 0 4.1241-.2831 5.946-.8494 1.8466-.5663 3.4839-1.3911 4.912-2.4745 1.428-1.1079 2.6098-2.4498 3.5454-4.0255.9602-1.5758 1.625-3.3731 1.9943-5.3921l16.1762.0739c-.4186 3.4716-1.465 6.8201-3.1392 10.0454-1.6497 3.2008-3.8779 6.0692-6.6847 8.6052-2.7822 2.5113-6.1061 4.5056-9.9716 5.9829-3.8409 1.4527-8.1865 2.179-13.0369 2.179-6.7462 0-12.7784-1.5265-18.0966-4.5796-5.2936-3.053-9.4792-7.4725-12.5568-13.2585-3.05305-5.786-4.57956-12.7907-4.57956-21.0142 0-8.2481 1.55113-15.2651 4.65336-21.0511 3.1023-5.786 7.3125-10.19321 12.6307-13.22162 5.3182-3.05303 11.3011-4.57955 17.9489-4.57955 4.3825 0 8.445.61553 12.1875 1.84659 3.767 1.23107 7.1032 3.02841 10.0085 5.39205 2.9053 2.33903 5.2689 5.20743 7.0909 8.60513 1.8466 3.3977 3.0284 7.2879 3.5455 11.6705z"
            fill={getBrandColor()}
          />
          <path
            d="m74.3095 28.8438v.75h.8436l-.0988-.8379zm-16.1762 0-.7426.1048.0911.6452h.6515zm-1.8096-5.5768-.6566.3626.0024.0042zm-8.4574-6.8693-.2372.7115.0028.001zm-16.25 1.9943.4136.6257.0036-.0024zm-6.7585 8.4205.6874.2999.0007-.0017zm0 26.9602-.6875.2999.0017.0039zm22.8238 10.2671-.2199-.7171-.0027.0009zm4.912-2.4745.4533.5976.0064-.005zm3.5454-4.0255-.6405-.3903-.0044.0074zm1.9943-5.3921.0034-.75-.6281-.0028-.113.6179zm16.1762.0739.7446.0898.1008-.836-.842-.0038zm-3.1392 10.0454-.6657-.3455-.001.002zm-16.6563 14.5881.2653.7015.0024-.0009zm-31.1335-2.4006-.3747.6497.0013.0008zm-12.5568-13.2585-.6634.35.0012.0022zm12.7045-55.28692.3711.65174.0023-.0013zm30.1364-2.73296-.2344.71245.0014.00045zm10.0085 5.39205-.4733.58179.003.00241zm7.0909 8.60513-.661.3544.002.0037zm3.5455 10.9205h-16.1762v1.5h16.1762zm-15.4335.6451c-.3068-2.1725-.936-4.1224-1.8981-5.8386l-1.3084.7335c.8598 1.5338 1.437 3.3017 1.7212 5.3148zm-1.8958-5.8344c-.9565-1.732-2.1879-3.2108-3.6929-4.4304l-.9443 1.1654c1.351 1.0948 2.4586 2.4229 3.3241 3.9901zm-3.6929-4.4304c-1.5037-1.2185-3.2352-2.1469-5.1867-2.7888l-.4687 1.4249c1.791.5891 3.3587 1.4334 4.7111 2.5293zm-5.1839-2.7879c-1.9311-.6437-4.0188-.9618-6.257-.9618v1.5c2.0951 0 4.0207.2975 5.7827.8848zm-6.257-.9618c-4.0449 0-7.6041 1.007-10.6474 3.0444l.8345 1.2465c2.7674-1.8528 6.0283-2.7909 9.8129-2.7909zm-10.6437 3.042c-3.0447 2.0126-5.3841 4.9425-7.0331 8.7479l1.3763.5964c1.5518-3.581 3.718-6.2647 6.484-8.093zm-7.0324 8.7462c-1.6523 3.7876-2.4631 8.3522-2.4631 13.6692h1.5c0-5.1716.7896-9.5199 2.338-13.0694zm-2.4631 13.6692c0 5.4614.8098 10.1009 2.4631 13.8908l1.3749-.5998c-1.5475-3.5472-2.338-7.9683-2.338-13.291zm2.4648 13.8947c1.6745 3.7803 4.0278 6.6738 7.0751 8.6364l.8122-1.261c-2.7633-1.7798-4.9403-4.4262-6.5158-7.9829zm7.0751 8.6364c3.0389 1.9573 6.5438 2.9263 10.4885 2.9263v-1.5c-3.6878 0-6.9045-.9022-9.6763-2.6873zm10.4885 2.9263c2.2084 0 4.2663-.292 6.1686-.8832l-.4452-1.4324c-1.7416.5413-3.6477.8156-5.7234.8156zm6.1659-.8824c1.9243-.5901 3.642-1.4534 5.1454-2.5939l-.9066-1.1951c-1.3526 1.0261-2.9096 1.8125-4.6786 2.3549zm5.1518-2.5989c1.5034-1.1664 2.7477-2.5797 3.7306-4.2352l-1.2898-.7658c-.8883 1.496-2.0076 2.7664-3.3603 3.8159zm3.7262-4.2278c1.0131-1.6626 1.7076-3.5482 2.0916-5.6474l-1.4755-.2699c-.3547 1.9387-.9898 3.6477-1.8971 5.1367zm1.3504-5.0324 16.1761.0739.0069-1.5-16.1762-.0739zm15.4349-.7659c-.4073 3.3788-1.4257 6.641-3.0602 9.7897l1.3313.6911c1.714-3.302 2.7884-6.7369 3.2182-10.3012zm-3.0612 9.7917c-1.6062 3.1165-3.7776 5.9136-6.5208 8.3922l1.0053 1.1132c2.8704-2.5935 5.1558-5.5332 6.8488-8.8183zm-6.5208 8.3922c-2.7067 2.4432-5.9485 4.3912-9.7365 5.8388l.5354 1.4012c3.9431-1.5069 7.3487-3.5473 10.2064-6.1268zm-9.7341 5.8379c-3.7423 1.4154-7.9958 2.1305-12.7716 2.1305v1.5c4.9249 0 9.3627-.7375 13.3022-2.2275zm-12.7716 2.1305c-6.6287 0-12.5298-1.4986-17.7232-4.48l-.7468 1.3009c5.4429 3.1246 11.6062 4.6791 18.47 4.6791zm-17.7219-4.4792c-5.1629-2.9777-9.2528-7.2899-12.2694-12.9611l-1.3243.7044c3.1387 5.9008 7.42 10.4276 12.8443 13.556zm-12.2682-12.9589c-2.98332-5.6539-4.49286-12.532-4.49286-20.6642h-1.5c0 8.3148 1.54348 15.4461 4.66616 21.3642zm-4.49286-20.6642c0-8.1555 1.53366-15.0442 4.56436-20.6967l-1.322-.7088c-3.17375 5.9194-4.74236 13.0648-4.74236 21.4055zm4.56436-20.6967c3.0406-5.671 7.1543-9.97085 12.3408-12.92428l-.7422-1.30348c-5.4499 3.10338-9.7566 7.61796-12.9206 13.51896zm12.3431-12.92558c5.1951-2.98237 11.0474-4.47999 17.5755-4.47999v-1.500001c-6.7674 0-12.881 1.555421-18.3223 4.679111zm17.5755-4.47999c4.3118 0 8.2943.60548 11.9531 1.80904l.4687-1.42489c-3.826-1.25857-7.9685-1.884151-12.4218-1.884151zm11.9545 1.80949c3.6847 1.20416 6.9383 2.9587 9.7682 5.26094l.9466-1.16358c-2.9808-2.42503-6.3995-4.26519-10.2489-5.52315zm9.7712 5.26335c2.8243 2.27383 5.1241 5.06313 6.9002 8.37533l1.322-.7088c-1.8679-3.4833-4.2953-6.4307-7.2816-8.83493zm6.9022 8.37903c1.7951 3.303 2.9522 7.0991 3.4596 11.4002l1.4897-.1757c-.5267-4.4641-1.7332-8.4482-3.6313-11.9407z"
            fill="#000"
          />
        </g>
      </g>
    </svg>
  ),

  letterD: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterD-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterD-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterD-c"
        fill="#000"
        height="80"
        maskUnits="userSpaceOnUse"
        width="68"
        x="6"
        y="0"
      >
        <path d="m6 0h68v80h-68z" fill="#fff" />
        <path
          d="m34.7074 78h-27.07033v-76.36364h27.29403c7.6811 0 14.2933 1.52877 19.8367 4.5863 5.5433 3.03266 9.8064 7.39524 12.7894 13.08774 3.0078 5.6924 4.5117 12.5035 4.5117 20.4332 0 7.9546-1.5039 14.7905-4.5117 20.5078-2.983 5.7173-7.271 10.1048-12.864 13.1623-5.5682 3.0575-12.2301 4.5863-19.9858 4.5863zm-10.9251-13.8335h10.2539c4.7727 0 8.7873-.8451 12.0437-2.5355 3.2813-1.7152 5.7422-4.3625 7.3828-7.9421 1.6655-3.6044 2.4982-8.2528 2.4982-13.9453 0-5.6427-.8327-10.2539-2.4982-13.8334-1.6406-3.5796-4.0891-6.2145-7.3455-7.9049-3.2564-1.6903-7.271-2.5355-12.0437-2.5355h-10.2912z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterD-a)">
        <path
          d="m34.7074 78h-27.07033v-76.36364h27.29403c7.6811 0 14.2933 1.52877 19.8367 4.5863 5.5433 3.03266 9.8064 7.39524 12.7894 13.08774 3.0078 5.6924 4.5117 12.5035 4.5117 20.4332 0 7.9546-1.5039 14.7905-4.5117 20.5078-2.983 5.7173-7.271 10.1048-12.864 13.1623-5.5682 3.0575-12.2301 4.5863-19.9858 4.5863zm-10.9251-13.8335h10.2539c4.7727 0 8.7873-.8451 12.0437-2.5355 3.2813-1.7152 5.7422-4.3625 7.3828-7.9421 1.6655-3.6044 2.4982-8.2528 2.4982-13.9453 0-5.6427-.8327-10.2539-2.4982-13.8334-1.6406-3.5796-4.0891-6.2145-7.3455-7.9049-3.2564-1.6903-7.271-2.5355-12.0437-2.5355h-10.2912z"
          fill={getBrandColor()}
        />
        <path
          d="m7.63707 78h-1.5v1.5h1.5zm0-76.36364v-1.499999h-1.5v1.499999zm47.13073 4.5863-.7245 1.31346.0045.00248zm12.7894 13.08774-1.3287.6962.0024.0045zm0 40.941-1.3275-.6984-.0024.0046zm-12.864 13.1623-.7195-1.3162-.0025.0014zm-30.9109-9.2472h-1.5v1.5h1.5zm22.2976-2.5355.6911 1.3314.0038-.002zm7.3828-7.9421-1.3617-.6292-.0019.0042zm0-27.7787-1.3636.6249.0036.0078zm-7.3455-7.9049.6911-1.3313zm-22.3349-2.5355v-1.5h-1.5v1.5zm10.9251 61.0302h-27.07033v3h27.07033zm-25.57033 1.5v-76.36364h-3v76.36364zm-1.5-74.86364h27.29403v-2.999999h-27.29403zm27.29403 0c7.4815 0 13.8334 1.48814 19.1122 4.39975l1.4489-2.62691c-5.8079-3.20345-12.6803-4.772839-20.5611-4.772839zm19.1167 4.40224c5.2791 2.8881 9.3326 7.0328 12.1807 12.468l2.6573-1.3925c-3.1178-5.9498-7.5905-10.53014-13.3981-13.70738zm12.1831 12.4725c2.8703 5.4321 4.338 11.9913 4.338 19.7325h3c0-8.1182-1.5401-15.1811-4.6855-21.134zm4.338 19.7325c0 7.7667-1.468 14.3517-4.3392 19.8094l2.655 1.3968c3.1444-5.9769 4.6842-13.0638 4.6842-21.2062zm-4.3416 19.814c-2.8473 5.4573-6.9244 9.6266-12.2536 12.5399l1.439 2.6324c5.8568-3.2018 10.3557-7.8073 13.4744-13.7846zm-12.2561 12.5413c-5.3031 2.9119-11.7053 4.4011-19.2638 4.4011v3c7.9528 0 14.8745-1.5684 20.7078-4.7715zm-30.1889-6.4324h10.2539v-3h-10.2539zm10.2539 0c4.9433 0 9.2104-.8747 12.7348-2.7041l-1.3822-2.6627c-2.9884 1.5513-6.7504 2.3668-11.3526 2.3668zm12.7386-2.7061c3.5955-1.8795 6.2817-4.785 8.0515-8.6465l-2.7272-1.25c-1.5114 3.2977-3.7471 5.6869-6.7141 7.2378zm8.0496-8.6423c1.7872-3.8679 2.6365-8.7521 2.6365-14.5745h-3c0 5.5625-.8161 9.9753-2.3598 13.3161zm2.6365-14.5745c0-5.7743-.8497-10.6223-2.6382-14.4662l-2.72 1.2655c1.5425 3.3152 2.3582 7.6895 2.3582 13.2007zm-2.6346-14.4584c-1.769-3.8596-4.4427-6.7553-8.018-8.6112l-1.3822 2.6626c2.9374 1.5248 5.1607 3.899 6.673 7.1985zm-8.018-8.6112c-3.5244-1.8294-7.7915-2.7042-12.7348-2.7042v3c4.6021 0 8.3642.8156 11.3526 2.3668zm-12.7348-2.7042h-10.2912v3h10.2912zm-11.7912 1.5v48.6967h3v-48.6967z"
          fill="#000"
          mask="url(#letterD-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterD-b)"
      />
    </svg>
  ),

  letterE: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterE-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterE-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterE-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="56"
        x="12"
        y="-1"
      >
        <path d="m12-1h56v82h-56z" fill="#fff" />
        <path
          d="m13.7635 79v-77.81818h52.4361v13.56498h-35.9833v18.5426h33.2855v13.565h-33.2855v18.5806h36.1353v13.565z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterE-a)">
        <path
          d="m13.7635 79v-77.81818h52.4361v13.56498h-35.9833v18.5426h33.2855v13.565h-33.2855v18.5806h36.1353v13.565z"
          fill={getBrandColor()}
        />
        <path
          d="m13.7635 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm52.4361 0h1.5v-1.500004h-1.5zm0 13.56498v1.5h1.5v-1.5zm-35.9833 0v-1.5h-1.5v1.5zm0 18.5426h-1.5v1.5h1.5zm33.2855 0h1.5v-1.5h-1.5zm0 13.565v1.5h1.5v-1.5zm-33.2855 0v-1.5h-1.5v1.5zm0 18.5806h-1.5v1.5h1.5zm36.1353 0h1.5v-1.5h-1.5zm0 13.565v1.5h1.5v-1.5zm-51.0881 0v-77.81818h-3v77.81818zm-1.5-76.31818h52.4361v-3.000004h-52.4361zm50.9361-1.5v13.56498h3v-13.56498zm1.5 12.06498h-35.9833v3h35.9833zm-37.4833 1.5v18.5426h3v-18.5426zm1.5 20.0426h33.2855v-3h-33.2855zm31.7855-1.5v13.565h3v-13.565zm1.5 12.065h-33.2855v3h33.2855zm-34.7855 1.5v18.5806h3v-18.5806zm1.5 20.0806h36.1353v-3h-36.1353zm34.6353-1.5v13.565h3v-13.565zm1.5 12.065h-52.5881v3h52.5881z"
          fill="#000"
          mask="url(#letterE-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterE-b)"
      />
    </svg>
  ),

  letterF: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterF-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterF-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterF-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="55"
        x="14"
        y="-1"
      >
        <path d="m14-1h55v82h-55z" fill="#fff" />
        <path
          d="m15.7635 79v-77.81818h51.5241v13.56498h-35.0713v18.5426h31.6516v13.565h-31.6516v32.1456z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterF-a)">
        <path
          d="m15.7635 79v-77.81818h51.5241v13.56498h-35.0713v18.5426h31.6516v13.565h-31.6516v32.1456z"
          fill={getBrandColor()}
        />
        <path
          d="m15.7635 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm51.5241 0h1.5v-1.500004h-1.5zm0 13.56498v1.5h1.5v-1.5zm-35.0713 0v-1.5h-1.5v1.5zm0 18.5426h-1.5v1.5h1.5zm31.6516 0h1.5v-1.5h-1.5zm0 13.565v1.5h1.5v-1.5zm-31.6516 0v-1.5h-1.5v1.5zm0 32.1456v1.5h1.5v-1.5zm-14.9528 0v-77.81818h-3v77.81818zm-1.5-76.31818h51.5241v-3.000004h-51.5241zm50.0241-1.5v13.56498h3v-13.56498zm1.5 12.06498h-35.0713v3h35.0713zm-36.5713 1.5v18.5426h3v-18.5426zm1.5 20.0426h31.6516v-3h-31.6516zm30.1516-1.5v13.565h3v-13.565zm1.5 12.065h-31.6516v3h31.6516zm-33.1516 1.5v32.1456h3v-32.1456zm1.5 30.6456h-16.4528v3h16.4528z"
          fill="#000"
          mask="url(#letterF-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterF-b)"
      />
    </svg>
  ),

  letterG: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterG-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterG-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterG-c"
        fill="#000"
        height="80"
        maskUnits="userSpaceOnUse"
        width="71"
        x="3"
        y="0"
      >
        <path d="m3 0h71v80h-71z" fill="#fff" />
        <path
          d="m55.6364 26.7969c-.5071-1.7628-1.2195-3.3203-2.1371-4.6726-.9176-1.3764-2.0405-2.5355-3.3686-3.4773-1.304-.9659-2.8012-1.7024-4.4915-2.2095-1.6662-.5071-3.5135-.7607-5.5419-.7607-3.7912 0-7.1236.9418-9.9972 2.8253-2.8494 1.8836-5.071 4.6243-6.6647 8.2223-1.5938 3.5739-2.3907 7.9446-2.3907 13.1122 0 5.1677.7848 9.5625 2.3544 13.1847 1.5697 3.6222 3.7912 6.3871 6.6648 8.2948 2.8736 1.8835 6.2664 2.8252 10.1783 2.8252 3.5497 0 6.5802-.6278 9.0916-1.8835 2.5355-1.2798 4.4673-3.0788 5.7955-5.397 1.3522-2.3182 2.0284-5.059 2.0284-8.2223l3.1875.4709h-19.125v-11.8083h31.0419v9.3452c0 6.5199-1.3764 12.1222-4.1293 16.8068-2.7528 4.6605-6.544 8.2585-11.3736 10.7941-4.8295 2.5113-10.3593 3.767-16.5895 3.767-6.9545 0-13.0639-1.5334-18.3281-4.6001-5.2642-3.0909-9.3693-7.4738-12.31532-13.1485-2.92188-5.6988-4.38281-12.4602-4.38281-20.2841 0-6.0128.86931-11.3735 2.60795-16.0824 1.76278-4.7329 4.22588-8.7414 7.38918-12.0255 3.1634-3.28411 6.8459-5.7834 11.0476-7.49789s8.7536-2.57174 13.6556-2.57174c4.2017 0 8.1136.61577 11.7357 1.84731 3.6222 1.20738 6.8339 2.92187 9.635 5.14346 2.8253 2.22156 5.1314 4.86576 6.9183 7.93256 1.7869 3.0426 2.934 6.3991 3.4411 10.0696z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterG-a)">
        <path
          d="m55.6364 26.7969c-.5071-1.7628-1.2195-3.3203-2.1371-4.6726-.9176-1.3764-2.0405-2.5355-3.3686-3.4773-1.304-.9659-2.8012-1.7024-4.4915-2.2095-1.6662-.5071-3.5135-.7607-5.5419-.7607-3.7912 0-7.1236.9418-9.9972 2.8253-2.8494 1.8836-5.071 4.6243-6.6647 8.2223-1.5938 3.5739-2.3907 7.9446-2.3907 13.1122 0 5.1677.7848 9.5625 2.3544 13.1847 1.5697 3.6222 3.7912 6.3871 6.6648 8.2948 2.8736 1.8835 6.2664 2.8252 10.1783 2.8252 3.5497 0 6.5802-.6278 9.0916-1.8835 2.5355-1.2798 4.4673-3.0788 5.7955-5.397 1.3522-2.3182 2.0284-5.059 2.0284-8.2223l3.1875.4709h-19.125v-11.8083h31.0419v9.3452c0 6.5199-1.3764 12.1222-4.1293 16.8068-2.7528 4.6605-6.544 8.2585-11.3736 10.7941-4.8295 2.5113-10.3593 3.767-16.5895 3.767-6.9545 0-13.0639-1.5334-18.3281-4.6001-5.2642-3.0909-9.3693-7.4738-12.31532-13.1485-2.92188-5.6988-4.38281-12.4602-4.38281-20.2841 0-6.0128.86931-11.3735 2.60795-16.0824 1.76278-4.7329 4.22588-8.7414 7.38918-12.0255 3.1634-3.28411 6.8459-5.7834 11.0476-7.49789s8.7536-2.57174 13.6556-2.57174c4.2017 0 8.1136.61577 11.7357 1.84731 3.6222 1.20738 6.8339 2.92187 9.635 5.14346 2.8253 2.22156 5.1314 4.86576 6.9183 7.93256 1.7869 3.0426 2.934 6.3991 3.4411 10.0696z"
          fill={getBrandColor()}
        />
        <path
          d="m55.6364 26.7969-1.4416.4147.3122 1.0853h1.1294zm-2.1371-4.6726-1.2481.8321.0069.0101zm-3.3686-3.4773-.8929 1.2054.0125.0092.0127.009zm-4.4915-2.2095-.4367 1.435.0057.0017zm-15.5391 2.0646-.8223-1.2545-.0048.0032zm-6.6647 8.2223 1.3699.611.0015-.0035zm6.6285 34.5916-.8296 1.2498.0073.0048zm19.2699.9418.6708 1.3417.0051-.0026zm5.7955-5.397-1.2957-.7558-.0059.0101zm2.0284-8.2223.2192-1.4839-1.7192-.254v1.7379zm3.1875.4709v1.5l.2192-2.9839zm-19.125 0h-1.5v1.5h1.5zm0-11.8083v-1.5h-1.5v1.5zm31.0419 0h1.5v-1.5h-1.5zm-4.1293 26.152 1.2915.7629.0018-.0029zm-11.3736 10.7941.6921 1.3308.0052-.0027zm-34.9176-.8331-.7595 1.2935.0045.0026zm-12.31532-13.1485-1.3348.6844.00351.0068zm-1.77486-36.3665-1.40567-.5235-.00147.004zm7.38918-12.0255 1.0804 1.0406zm11.0476-7.49789-.5667-1.38883zm25.3913-.72443-.4828 1.42018.0085.00284zm9.635 5.14346-.9321 1.17526.0049.00387zm6.9183 7.93256-1.296.7551.0026.0045zm3.4411 10.0696v1.5h1.7214l-.2355-1.7053zm-14.496-.4147c-.5456-1.8966-1.3207-3.6019-2.3374-5.1002l-2.4824 1.6845c.8185 1.2063 1.4681 2.6161 1.9367 4.2451zm-2.3305-5.09c-1.0178-1.5266-2.2688-2.8191-3.7491-3.8688l-1.7353 2.4472c1.176.8339 2.1707 1.8595 2.9882 3.0857zm-3.7239-3.8505c-1.4551-1.0779-3.1113-1.8884-4.9533-2.4409l-.862 2.8734c1.5387.4617 2.8768 1.1242 4.0296 1.9782zm-4.9476-2.4392c-1.8288-.5566-3.826-.8257-5.9786-.8257v3c1.9042 0 3.6016.2381 5.1052.6957zm-5.9786-.8257c-4.052 0-7.6765 1.0107-10.8195 3.0708l1.6446 2.5091c2.6043-1.707 5.6445-2.5799 9.1749-2.5799zm-10.8243 3.074c-3.1234 2.0646-5.5173 5.0467-7.2091 8.8661l2.7429 1.215c1.4957-3.3766 3.545-5.876 6.1205-7.5784zm-7.2076 8.8627c-1.7023 3.8172-2.5207 8.4093-2.5207 13.7231h3c0-5.0213.7754-9.1707 2.2606-12.5012zm-2.5207 13.7231c0 5.3124.8059 9.9222 2.4781 13.7811l2.7527-1.1928c-1.467-3.3854-2.2308-7.5654-2.2308-12.5883zm2.4781 13.7811c1.6678 3.8487 4.0629 6.8578 7.2115 8.948l1.6592-2.4993c-2.5985-1.7251-4.6466-4.2459-6.118-7.6415zm7.2188 8.9529c3.1506 2.0651 6.8382 3.0707 11.0006 3.0707v-3c-3.6615 0-6.7594-.8778-9.356-2.5798zm11.0006 3.0707c3.7227 0 6.9951-.6582 9.7624-2.0418l-1.3416-2.6833c-2.2554 1.1277-5.0441 1.7251-8.4208 1.7251zm9.7675-2.0444c2.7803-1.4034 4.9376-3.4011 6.4211-5.9904l-2.6031-1.4914c-1.1727 2.0471-2.8791 3.6473-5.1698 4.8036zm6.4152-5.9803c1.5083-2.5856 2.2328-5.597 2.2328-8.9781h-3c0 2.9456-.6278 5.4158-1.8241 7.4665zm.5136-7.4942 3.1875.4709.4384-2.9678-3.1875-.4709zm3.4067-2.513h-19.125v3h19.125zm-17.625 1.5v-11.8083h-3v11.8083zm-1.5-10.3083h31.0419v-3h-31.0419zm29.5419-1.5v9.3452h3v-9.3452zm0 9.3452c0 6.3062-1.3298 11.6348-3.9225 16.0469l2.5865 1.5199c2.913-4.9572 4.336-10.8333 4.336-17.5668zm-3.9208 16.044c-2.61 4.4186-6.1945 7.8217-10.7793 10.2288l1.3945 2.6562c5.0743-2.664 9.0721-6.4569 11.9678-11.3593zm-10.7741 10.226c-4.5867 2.3851-9.8732 3.5979-15.8975 3.5979v3c6.436 0 12.2092-1.2986 17.2816-3.9362zm-15.8975 3.5979c-6.7274 0-12.5689-1.481-17.573-4.3962l-1.5101 2.5922c5.5243 3.2183 11.9015 4.804 19.0831 4.804zm-17.5686-4.3936c-5.0089-2.941-8.9211-7.1095-11.7435-12.5461l-2.66261 1.3823c3.06961 5.9128 7.36761 10.51 12.88711 13.7508zm-11.74-12.5393c-2.79185-5.4452-4.21763-11.9619-4.21763-19.5998h-3c0 8.0099 1.49609 15.016 4.54802 20.9685zm-4.21763-19.5998c0-5.8696.84869-11.0496 2.5151-15.5628l-2.81429-1.0391c-1.81087 4.9044-2.70081 10.446-2.70081 16.6019zm2.51362-15.5588c1.69871-4.561 4.05791-8.3879 7.06391-11.5085l-2.1607-2.0812c-3.3208 3.4475-5.8877 7.6376-7.71455 12.5426zm7.06391-11.5085c3.019-3.13424 6.5268-5.51457 10.5339-7.14966l-1.1334-2.77766c-4.3963 1.79388-8.2535 4.41214-11.5612 7.84612zm10.5339-7.14966c4.0078-1.63537 8.3655-2.46057 13.0889-2.46057v-2.999996c-5.0806 0-9.8267.889286-14.2223 2.682906zm13.0889-2.46057c4.0535 0 7.8007.59373 11.2529 1.76747l.9657-2.84032c-3.7922-1.28934-7.8688-1.927146-12.2186-1.927146zm11.2614 1.77033c3.4676 1.15588 6.5221 2.78992 9.1772 4.89569l1.8642-2.35049c-2.9472-2.33742-6.316-4.13235-10.0927-5.39125zm9.1821 4.89957c2.6787 2.10623 4.8589 4.60723 6.5495 7.50853l2.592-1.5103c-1.8832-3.2322-4.3152-6.01958-7.2871-8.35649zm6.5521 7.51303c1.6819 2.8638 2.7671 6.0305 3.2486 9.5153l2.9718-.4106c-.5328-3.8562-1.7416-7.4026-3.6336-10.624zm4.7345 7.81h-15.9375v3h15.9375z"
          fill="#000"
          mask="url(#letterG-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterG-b)"
      />
    </svg>
  ),

  letterH: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterH-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterH-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterH-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="70"
        x="5"
        y="-1"
      >
        <path d="m5-1h70v82h-70z" fill="#fff" />
        <path
          d="m6.76349 79v-77.81818h16.45281v32.10758h33.3995v-32.10758h16.4147v77.81818h-16.4147v-32.1456h-33.3995v32.1456z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterH-a)">
        <path
          d="m6.76349 79v-77.81818h16.45281v32.10758h33.3995v-32.10758h16.4147v77.81818h-16.4147v-32.1456h-33.3995v32.1456z"
          fill={getBrandColor()}
        />
        <path
          d="m6.76349 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm16.45281 0h1.5v-1.500004h-1.5zm0 32.10758h-1.5v1.5h1.5zm33.3995 0v1.5h1.5v-1.5zm0-32.10758v-1.500004h-1.5v1.500004zm16.4147 0h1.5v-1.500004h-1.5zm0 77.81818v1.5h1.5v-1.5zm-16.4147 0h-1.5v1.5h1.5zm0-32.1456h1.5v-1.5h-1.5zm-33.3995 0v-1.5h-1.5v1.5zm0 32.1456v1.5h1.5v-1.5zm-14.95281 0v-77.81818h-3v77.81818zm-1.5-76.31818h16.45281v-3.000004h-16.45281zm14.95281-1.5v32.10758h3v-32.10758zm1.5 33.60758h33.3995v-3h-33.3995zm34.8995-1.5v-32.10758h-3v32.10758zm-1.5-30.60758h16.4147v-3.000004h-16.4147zm14.9147-1.5v77.81818h3v-77.81818zm1.5 76.31818h-16.4147v3h16.4147zm-14.9147 1.5v-32.1456h-3v32.1456zm-1.5-33.6456h-33.3995v3h33.3995zm-34.8995 1.5v32.1456h3v-32.1456zm1.5 30.6456h-16.45281v3h16.45281z"
          fill="#000"
          mask="url(#letterH-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterH-b)"
      />
    </svg>
  ),

  letterI: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterI-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterI-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterI-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="20"
        x="30"
        y="-1"
      >
        <path d="m30-1h20v82h-20z" fill="#fff" />
        <path d="m48.2163 1.18182v77.81818h-16.4528v-77.81818z" fill="#000" />
      </mask>
      <g clipPath="url(#letterI-a)">
        <path
          d="m48.2163 1.18182v77.81818h-16.4528v-77.81818z"
          fill={getBrandColor()}
        />
        <path
          d="m48.2163 1.18182h1.5v-1.500004h-1.5zm0 77.81818v1.5h1.5v-1.5zm-16.4528 0h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm14.9528 0v77.81818h3v-77.81818zm1.5 76.31818h-16.4528v3h16.4528zm-14.9528 1.5v-77.81818h-3v77.81818zm-1.5-76.31818h16.4528v-3.000004h-16.4528z"
          fill="#000"
          mask="url(#letterI-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterI-b)"
      />
    </svg>
  ),

  letterJ: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterJ-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterJ-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterJ-c"
        fill="#000"
        height="81"
        maskUnits="userSpaceOnUse"
        width="54"
        x="11"
        y="-1"
      >
        <path d="m11-1h54v81h-54z" fill="#fff" />
        <path
          d="m47.2017 1.36363h15.8068v52.73867c0 4.875-1.0956 9.1098-3.2869 12.7045-2.1667 3.5947-5.1828 6.3646-9.0483 8.3097s-8.3589 2.9176-13.4801 2.9176c-4.5549 0-8.6913-.8002-12.4091-2.4006-3.6932-1.625-6.6231-4.0871-8.7898-7.3863-2.1666-3.3239-3.2377-7.4972-3.2131-12.5199h15.9177c.0492 1.9943.4555 3.7055 1.2187 5.1335.7879 1.4034 1.8589 2.4867 3.2131 3.25 1.3788.7386 3.0038 1.108 4.875 1.108 1.9697 0 3.6316-.4186 4.9858-1.2557 1.3788-.8618 2.4252-2.1175 3.1392-3.7671s1.071-3.6808 1.071-6.0937z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterJ-a)">
        <path
          d="m47.2017 1.36363h15.8068v52.73867c0 4.875-1.0956 9.1098-3.2869 12.7045-2.1667 3.5947-5.1828 6.3646-9.0483 8.3097s-8.3589 2.9176-13.4801 2.9176c-4.5549 0-8.6913-.8002-12.4091-2.4006-3.6932-1.625-6.6231-4.0871-8.7898-7.3863-2.1666-3.3239-3.2377-7.4972-3.2131-12.5199h15.9177c.0492 1.9943.4555 3.7055 1.2187 5.1335.7879 1.4034 1.8589 2.4867 3.2131 3.25 1.3788.7386 3.0038 1.108 4.875 1.108 1.9697 0 3.6316-.4186 4.9858-1.2557 1.3788-.8618 2.4252-2.1175 3.1392-3.7671s1.071-3.6808 1.071-6.0937z"
          fill={getBrandColor()}
        />
        <path
          d="m47.2017 1.36363v-1.499996h-1.5v1.499996zm15.8068 0h1.5v-1.499996h-1.5zm-3.2869 65.44317-1.2808-.7807-.0039.0064zm-9.0483 8.3097-.6742-1.3399zm-25.8892.517-.6041 1.373.011.0048zm-8.7898-7.3863-1.2566.8191.0028.0042zm-3.2131-12.5199v-1.5h-1.4926l-.0073 1.4926zm15.9177 0 1.4995-.0371-.0361-1.4629h-1.4634zm1.2187 5.1335-1.3229.7071.0073.0137.0076.0135zm3.2131 3.25-.7365 1.3067.014.0079.0141.0076zm9.8608-.1477.7887 1.2759.0063-.0039zm3.1392-3.7671 1.3766.5959zm1.071-57.33237h15.8068v-2.999996h-15.8068zm14.3068-1.5v52.73867h3v-52.73867zm0 52.73867c0 4.6438-1.0412 8.5994-3.0677 11.9238l2.5616 1.5615c2.356-3.865 3.5061-8.3791 3.5061-13.4853zm-3.0716 11.9302c-2.0159 3.3446-4.8168 5.922-8.4378 7.7441l1.3484 2.6798c4.1101-2.0681 7.3413-5.0304 9.6588-8.8753zm-8.4378 7.7441c-3.6213 1.8221-7.8761 2.7575-12.8059 2.7575v3c5.3126 0 10.0445-1.0097 14.1543-3.0777zm-12.8059 2.7575c-4.3765 0-8.3077-.7681-11.816-2.2783l-1.1862 2.7555c3.9273 1.6905 8.2689 2.5228 13.0022 2.5228zm-11.805-2.2735c-3.4344-1.5112-6.1361-3.7853-8.1401-6.8368l-2.5076 1.6467c2.3294 3.547 5.4875 6.1971 9.4395 7.936zm-8.1373-6.8326c-1.9687-3.0202-2.9932-6.8863-2.9697-11.6934l-2.9999-.0147c-.0257 5.2384 1.0918 9.7189 3.4564 13.3464zm-4.4697-10.2007h15.9177v-3h-15.9177zm14.4181-1.463c.0537 2.1751.4991 4.1266 1.3954 5.8036l2.6458-1.4142c-.6302-1.1791-.9973-2.6499-1.0421-4.4635zm1.4103 5.8308c.9174 1.6341 2.1824 2.9194 3.7846 3.8224l1.473-2.6134c-1.1061-.6235-1.9832-1.5048-2.6416-2.6776zm3.8127 3.8379c1.6356.8762 3.5133 1.2858 5.5834 1.2858v-3c-1.6724 0-3.0447-.3292-4.1667-.9302zm5.5834 1.2858c2.1824 0 4.1329-.465 5.7745-1.4798l-1.5775-2.5518c-1.0667.6594-2.44 1.0316-4.197 1.0316zm5.7808-1.4837c1.6637-1.0399 2.8992-2.5452 3.7208-4.4432l-2.7532-1.1917c-.6065 1.4012-1.4638 2.4072-2.5576 3.0909zm3.7208-4.4432c.8182-1.8903 1.1944-4.1381 1.1944-6.6896h-3c0 2.2742-.3378 4.0889-.9476 5.4979zm1.1944-6.6896v-52.73867h-3v52.73867z"
          fill="#000"
          mask="url(#letterJ-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterJ-b)"
      />
    </svg>
  ),

  letterK: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterK-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterK-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterK-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="71"
        x="8"
        y="-1"
      >
        <path d="m8-1h71v82h-71z" fill="#fff" />
        <path
          d="m9.87775 79v-77.81818h16.45275v34.31148h1.0259l28.004-34.31148h19.7205l-28.8779 34.84338 29.2199 42.9748h-19.6826l-21.3164-31.9936-8.0934 9.8793v22.1143z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterK-a)">
        <path
          d="m9.87775 79v-77.81818h16.45275v34.31148h1.0259l28.004-34.31148h19.7205l-28.8779 34.84338 29.2199 42.9748h-19.6826l-21.3164-31.9936-8.0934 9.8793v22.1143z"
          fill={getBrandColor()}
        />
        <path
          d="m9.87775 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm16.45275 0h1.5v-1.500004h-1.5zm0 34.31148h-1.5v1.5h1.5zm1.0259 0v1.5h.712l.4501-.5516zm28.004-34.31148v-1.500004h-.712l-.4501.551545zm19.7205 0 1.1549.95717 2.0365-2.457174h-3.1914zm-28.8779 34.84338-1.1549-.9572-.7195.8682.634.9324zm29.2199 42.9748v1.5h2.8337l-1.5933-2.3434zm-19.6826 0-1.2483.8317.4453.6683h.803zm-21.3164-31.9936 1.2483-.8317-1.124-1.687-1.2846 1.5681zm-8.0934 9.8793-1.1603-.9506-.3397.4146v.536zm0 22.1143v1.5h1.5v-1.5zm-14.9527 0v-77.81818h-3.00005v77.81818zm-1.50005-76.31818h16.45275v-3.000004h-16.45275zm14.95275-1.5v34.31148h3v-34.31148zm1.5 35.81148h1.0259v-3h-1.0259zm2.188-.5516 28.0039-34.31143-2.3241-1.896909-28.0039 34.311439zm26.8419-33.75988h19.7205v-3.000004h-19.7205zm18.5656-2.45718-28.8779 34.84336 2.3098 1.9144 28.8779-34.84341zm-28.9634 36.64396 29.2198 42.9748 2.4809-1.6868-29.2198-42.9748zm30.4603 40.6314h-19.6826v3h19.6826zm-18.4343.6683-21.3164-31.9936-2.4966 1.6634 21.3164 31.9936zm-23.725-32.1125-8.0934 9.8793 2.3207 1.9011 8.0934-9.8792zm-8.4331 10.8299v22.1143h3v-22.1143zm1.5 20.6143h-16.45275v3h16.45275z"
          fill="#000"
          mask="url(#letterK-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterK-b)"
      />
    </svg>
  ),

  letterL: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterL-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterL-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterL-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="54"
        x="15"
        y="-1"
      >
        <path d="m15-1h54v82h-54z" fill="#fff" />
        <path
          d="m16.9085 79v-77.81818h16.4528v64.25318h33.3615v13.565z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterL-a)">
        <path
          d="m16.9085 79v-77.81818h16.4528v64.25318h33.3615v13.565z"
          fill={getBrandColor()}
        />
        <path
          d="m16.9085 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm16.4528 0h1.5v-1.500004h-1.5zm0 64.25318h-1.5v1.5h1.5zm33.3615 0h1.5v-1.5h-1.5zm0 13.565v1.5h1.5v-1.5zm-48.3143 0v-77.81818h-3v77.81818zm-1.5-76.31818h16.4528v-3.000004h-16.4528zm14.9528-1.5v64.25318h3v-64.25318zm1.5 65.75318h33.3615v-3h-33.3615zm31.8615-1.5v13.565h3v-13.565zm1.5 12.065h-49.8143v3h49.8143z"
          fill="#000"
          mask="url(#letterL-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterL-b)"
      />
    </svg>
  ),

  letterM: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterM-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterM-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterM-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="88"
        x="-4"
        y="-1"
      >
        <path d="m-4-1h88v82h-88z" fill="#fff" />
        <path
          d="m-2.1911 1.18182h20.2905l21.4304 52.28408h.9119l21.4304-52.28408h20.2905v77.81818h-15.9588v-50.6502h-.646l-20.1385 50.2702h-10.8671l-20.1385-50.4602h-.646v50.8402h-15.9588z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterM-a)">
        <path
          d="m-2.1911 1.18182h20.2905l21.4304 52.28408h.9119l21.4304-52.28408h20.2905v77.81818h-15.9588v-50.6502h-.646l-20.1385 50.2702h-10.8671l-20.1385-50.4602h-.646v50.8402h-15.9588z"
          fill={getBrandColor()}
        />
        <path
          d="m-2.1911 1.18182v-1.500004h-1.5v1.500004zm20.2905 0 1.3879-.568895-.3816-.931109h-1.0063zm21.4304 52.28408-1.388.5689.3817.9311h1.0063zm.9119 0v1.5h1.0063l.3817-.9311zm21.4304-52.28408v-1.500004h-1.0063l-.3816.931109zm20.2905 0h1.5v-1.500004h-1.5zm0 77.81818v1.5h1.5v-1.5zm-15.9588 0h-1.5v1.5h1.5zm0-50.6502h1.5v-1.5h-1.5zm-.646 0v-1.5h-1.0149l-.3775.9422zm-20.1385 50.2702v1.5h1.015l.3775-.9422zm-10.8671 0-1.3932.556.3768.944h1.0164zm-20.1385-50.4602 1.3931-.556-.3767-.944h-1.0164zm-.646 0v-1.5h-1.5v1.5zm0 50.8402v1.5h1.5v-1.5zm-15.9588 0h-1.5v1.5h1.5zm0-76.31818h20.2905v-3.000004h-20.2905zm18.9026-.93111 21.4303 52.28409 2.7759-1.1378-21.4304-52.284075zm22.8183 53.21519h.9119v-3h-.9119zm2.2999-.9311 21.4303-52.28409-2.7758-1.137785-21.4304 52.284075zm20.0424-51.35298h20.2905v-3.000004h-20.2905zm18.7905-1.5v77.81818h3v-77.81818zm1.5 76.31818h-15.9588v3h15.9588zm-14.4588 1.5v-50.6502h-3v50.6502zm-1.5-52.1502h-.646v3h.646zm-2.0384.9422-20.1385 50.2702 2.7849 1.1156 20.1385-50.2702zm-18.7461 49.328h-10.8671v3h10.8671zm-9.474.944-20.1385-50.4602-2.7863 1.112 20.1385 50.4602zm-21.5316-51.4042h-.646v3h.646zm-2.146 1.5v50.8402h3v-50.8402zm1.5 49.3402h-15.9588v3h15.9588zm-14.458795 1.5v-77.81818h-3.000005v77.81818z"
          fill="#000"
          mask="url(#letterM-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterM-b)"
      />
    </svg>
  ),

  letterN: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterN-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterN-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterN-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="69"
        x="6"
        y="-1"
      >
        <path d="m6-1h69v82h-69z" fill="#fff" />
        <path
          d="m73.0113 1.18182v77.81818h-14.2109l-33.8555-48.9783h-.5699v48.9783h-16.45281v-77.81818h14.43891l33.5895 48.94038h.6839v-48.94038z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterN-a)">
        <path
          d="m73.0113 1.18182v77.81818h-14.2109l-33.8555-48.9783h-.5699v48.9783h-16.45281v-77.81818h14.43891l33.5895 48.94038h.6839v-48.94038z"
          fill={getBrandColor()}
        />
        <path
          d="m73.0113 1.18182h1.5v-1.500004h-1.5zm0 77.81818v1.5h1.5v-1.5zm-14.2109 0-1.2339.8529.4473.6471h.7866zm-33.8555-48.9783 1.2339-.853-.4473-.647h-.7866zm-.5699 0v-1.5h-1.5v1.5zm0 48.9783v1.5h1.5v-1.5zm-16.45281 0h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm14.43891 0 1.2367-.848819-.4469-.651185h-.7898zm33.5895 48.94038-1.2367.8488.4469.6512h.7898zm.6839 0v1.5h1.5v-1.5zm0-48.94038v-1.500004h-1.5v1.500004zm14.8768 0v77.81818h3v-77.81818zm1.5 76.31818h-14.2109v3h14.2109zm-12.977.6471-33.8555-48.9784-2.4678 1.7059 33.8555 48.9783zm-35.0894-49.6254h-.5699v3h.5699zm-2.0699 1.5v48.9783h3v-48.9783zm1.5 47.4783h-16.45281v3h16.45281zm-14.95281 1.5v-77.81818h-3v77.81818zm-1.5-76.31818h14.43891v-3.000004h-14.43891zm13.20221-.65119 33.5895 48.94037 2.4734-1.6977-33.5895-48.940299zm34.8262 49.59157h.6839v-3h-.6839zm2.1839-1.5v-48.94038h-3v48.94038zm-1.5-47.44038h16.3768v-3.000004h-16.3768z"
          fill="#000"
          mask="url(#letterN-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterN-b)"
      />
    </svg>
  ),

  letterO: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterO-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterO-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterO-c"
        fill="#000"
        height="80"
        maskUnits="userSpaceOnUse"
        width="74"
        x="3"
        y="0"
      >
        <path d="m3 0h74v80h-74z" fill="#fff" />
        <path
          d="m74.7229 39.9091c0 8.0895-1.5334 14.9716-4.6001 20.6463-3.0426 5.6747-7.196 10.0092-12.4602 13.0035-5.2401 2.9702-11.1321 4.4553-17.6762 4.4553-6.5923 0-12.5085-1.4972-17.7486-4.4915-5.24-2.9943-9.3814-7.3288-12.42397-13.0035-3.04261-5.6747-4.56392-12.5448-4.56392-20.6101 0-8.0895 1.52131-14.9716 4.56392-20.6463 3.04257-5.6747 7.18397-9.99718 12.42397-12.96734 5.2401-2.99433 11.1563-4.49149 17.7486-4.49149 6.5441 0 12.4361 1.49716 17.6762 4.49149 5.2642 2.97016 9.4176 7.29264 12.4602 12.96734 3.0667 5.6747 4.6001 12.5568 4.6001 20.6463zm-15.9013 0c0-5.2401-.7848-9.6591-2.3544-13.2571-1.5454-3.598-3.7308-6.3267-6.5561-8.1861s-6.1335-2.7891-9.9247-2.7891-7.0994.9297-9.9247 2.7891-5.0227 4.5881-6.5923 8.1861c-1.5455 3.598-2.3182 8.017-2.3182 13.2571 0 5.24.7727 9.6591 2.3182 13.2571 1.5696 3.598 3.767 6.3267 6.5923 8.1861 2.8253 1.8593 6.1335 2.789 9.9247 2.789s7.0994-.9297 9.9247-2.789c2.8253-1.8594 5.0107-4.5881 6.5561-8.1861 1.5696-3.598 2.3544-8.0171 2.3544-13.2571z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterO-a)">
        <path
          d="m74.7229 39.9091c0 8.0895-1.5334 14.9716-4.6001 20.6463-3.0426 5.6747-7.196 10.0092-12.4602 13.0035-5.2401 2.9702-11.1321 4.4553-17.6762 4.4553-6.5923 0-12.5085-1.4972-17.7486-4.4915-5.24-2.9943-9.3814-7.3288-12.42397-13.0035-3.04261-5.6747-4.56392-12.5448-4.56392-20.6101 0-8.0895 1.52131-14.9716 4.56392-20.6463 3.04257-5.6747 7.18397-9.99718 12.42397-12.96734 5.2401-2.99433 11.1563-4.49149 17.7486-4.49149 6.5441 0 12.4361 1.49716 17.6762 4.49149 5.2642 2.97016 9.4176 7.29264 12.4602 12.96734 3.0667 5.6747 4.6001 12.5568 4.6001 20.6463zm-15.9013 0c0-5.2401-.7848-9.6591-2.3544-13.2571-1.5454-3.598-3.7308-6.3267-6.5561-8.1861s-6.1335-2.7891-9.9247-2.7891-7.0994.9297-9.9247 2.7891-5.0227 4.5881-6.5923 8.1861c-1.5455 3.598-2.3182 8.017-2.3182 13.2571 0 5.24.7727 9.6591 2.3182 13.2571 1.5696 3.598 3.767 6.3267 6.5923 8.1861 2.8253 1.8593 6.1335 2.789 9.9247 2.789s7.0994-.9297 9.9247-2.789c2.8253-1.8594 5.0107-4.5881 6.5561-8.1861 1.5696-3.598 2.3544-8.0171 2.3544-13.2571z"
          fill={getBrandColor()}
        />
        <path
          d="m70.1228 60.5554-1.3196-.7132-.0024.0044zm-12.4602 13.0036.7396 1.3049.002-.0011zm-35.4248-.0363.7442-1.3023zm-12.42397-13.0035-1.32197.7088zm0-41.2564 1.32197.7088zm12.42397-12.96734.7397 1.30495.0045-.00259zm35.4248 0-.7443 1.30238.0072.00402zm12.4602 12.96734-1.322.7088.0024.0043zm-13.6556 7.3892-1.3782.592.0034.0078zm-6.5561-8.1861-.8246 1.253zm-19.8494 0 .8246 1.253zm-6.5923 8.1861-1.3749-.5998-.0034.0078zm0 26.5142-1.3783.592.0034.0078zm6.5923 8.1861.8246-1.253zm19.8494 0-.8246-1.253zm6.5561-8.1861-1.3748-.5998-.0034.0078zm16.7557-13.2571c0 7.9026-1.4977 14.5263-4.4197 19.9331l2.6392 1.4264c3.2115-5.9426 4.7805-13.0831 4.7805-21.3595zm-4.4221 19.9375c-2.9179 5.4421-6.877 9.5629-11.8799 12.4085l1.4833 2.6077c5.5256-3.143 9.8732-7.6913 13.0406-13.5986zm-11.8779 12.4074c-4.9953 2.8314-10.6286 4.2602-16.9365 4.2602v3c6.7803 0 12.931-1.5414 18.4158-4.6503zm-16.9365 4.2602c-6.356 0-12.0115-1.4408-17.0044-4.2938l-1.4884 2.6047c5.4873 3.1356 11.6642 4.6891 18.4928 4.6891zm-17.0044-4.2938c-4.979-2.8452-8.9274-6.9661-11.8462-12.41l-2.64394 1.4176c3.16634 5.9055 7.50074 10.4536 13.00174 13.5971zm-11.8462-12.41c-2.89984-5.4085-4.38589-12.022-4.38589-19.9013h-3c0 8.2513 1.55657 15.3779 4.74195 21.3189zm-4.38589-19.9013c0-7.9043 1.48636-14.5297 4.38589-19.9375l-2.64394-1.4176c-3.1857 5.9416-4.74195 13.0804-4.74195 21.3551zm4.38589-19.9375c2.9184-5.443 6.8653-9.5505 11.8417-12.3712l-1.4793-2.60989c-5.5038 3.11963-9.8395 7.65699-13.00634 13.56349zm11.8462-12.37378c4.9929-2.85305 10.6484-4.29385 17.0044-4.29385v-2.999996c-6.8286 0-13.0055 1.553526-18.4928 4.689116zm17.0044-4.29385c6.3057 0 11.9374 1.43985 16.9319 4.29385l1.4885-2.60473c-5.4856-3.13464-11.638-4.689116-18.4204-4.689116zm16.9391 4.29789c5.0001 2.82114 8.9579 6.92854 11.8753 12.36974l2.644-1.4176c-3.1679-5.9082-7.5169-10.4458-13.0451-13.56495zm11.8777 12.37404c2.922 5.4069 4.4197 12.0306 4.4197 19.9332h3c0-8.2764-1.569-15.4169-4.7805-21.3595zm-8.4816 19.9332c0-5.381-.8047-10.0177-2.4795-13.8569l-2.7497 1.1996c1.4644 3.3568 2.2292 7.5582 2.2292 12.6573zm-2.4761-13.8491c-1.6426-3.8242-4.0023-6.802-7.1097-8.8471l-1.6493 2.506c2.5432 1.6737 4.5542 4.1532 6.0025 7.5251zm-7.1097-8.8471c-3.0991-2.0395-6.7018-3.0361-10.7494-3.0361v3c3.5348 0 6.5486.8629 9.1001 2.5421zm-10.7494-3.0361c-4.0476 0-7.6503.9966-10.7493 3.0361l1.6492 2.506c2.5515-1.6792 5.5654-2.5421 9.1001-2.5421zm-10.7493 3.0361c-3.1052 2.0436-5.4759 5.0186-7.1426 8.8393l2.7497 1.1996c1.4725-3.3754 3.4967-5.8577 6.0421-7.5329zm-7.146 8.8471c-1.648 3.8368-2.4399 8.4706-2.4399 13.8491h3c0-5.1016.7535-9.3059 2.1964-12.6651zm-2.4399 13.8491c0 5.3785.7919 10.0123 2.4399 13.8491l2.7565-1.184c-1.4429-3.3592-2.1964-7.5635-2.1964-12.6651zm2.4433 13.8569c1.6667 3.8207 4.0374 6.7957 7.1426 8.8393l1.6492-2.506c-2.5454-1.6752-4.5696-4.1576-6.0421-7.5329zm7.1426 8.8393c3.099 2.0395 6.7017 3.036 10.7493 3.036v-3c-3.5347 0-6.5486-.8628-9.1001-2.542zm10.7493 3.036c4.0476 0 7.6503-.9965 10.7494-3.036l-1.6493-2.506c-2.5515 1.6792-5.5653 2.542-9.1001 2.542zm10.7494-3.036c3.1074-2.0451 5.4671-5.023 7.1097-8.8471l-2.7565-1.184c-1.4483 3.3719-3.4593 5.8514-6.0025 7.5251zm7.1063-8.8393c1.6748-3.8392 2.4795-8.4759 2.4795-13.8569h-3c0 5.0991-.7648 9.3005-2.2292 12.6573z"
          fill="#000"
          mask="url(#letterO-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterO-b)"
      />
    </svg>
  ),

  letterP: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterP-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterP-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterP-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="63"
        x="10"
        y="-1"
      >
        <path d="m10-1h63v82h-63z" fill="#fff" />
        <path
          d="m12.1243 79v-77.81818h30.7017c5.9023 0 10.9306 1.12725 15.0849 3.38174 4.1544 2.22917 7.3208 5.33227 9.4993 9.30934 2.2038 3.9517 3.3058 8.5113 3.3058 13.6789 0 5.1677-1.1146 9.7273-3.3438 13.679s-5.4589 7.0295-9.6893 9.2333c-4.205 2.2039-9.2966 3.3058-15.2748 3.3058h-19.5686v-13.185h16.9088c3.1664 0 5.7755-.5447 7.8274-1.6339 2.0772-1.1146 3.6224-2.6471 4.6356-4.5977 1.0386-1.9758 1.5579-4.243 1.5579-6.8015 0-2.5838-.5193-4.8383-1.5579-6.7635-1.0132-1.9505-2.5584-3.4577-4.6356-4.5216-2.0772-1.0893-4.7117-1.6339-7.9034-1.6339h-11.0952v64.3672z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterP-a)">
        <path
          d="m12.1243 79v-77.81818h30.7017c5.9023 0 10.9306 1.12725 15.0849 3.38174 4.1544 2.22917 7.3208 5.33227 9.4993 9.30934 2.2038 3.9517 3.3058 8.5113 3.3058 13.6789 0 5.1677-1.1146 9.7273-3.3438 13.679s-5.4589 7.0295-9.6893 9.2333c-4.205 2.2039-9.2966 3.3058-15.2748 3.3058h-19.5686v-13.185h16.9088c3.1664 0 5.7755-.5447 7.8274-1.6339 2.0772-1.1146 3.6224-2.6471 4.6356-4.5977 1.0386-1.9758 1.5579-4.243 1.5579-6.8015 0-2.5838-.5193-4.8383-1.5579-6.7635-1.0132-1.9505-2.5584-3.4577-4.6356-4.5216-2.0772-1.0893-4.7117-1.6339-7.9034-1.6339h-11.0952v64.3672z"
          fill={getBrandColor()}
        />
        <path
          d="m12.1243 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm45.7866 3.38174-.7155 1.3184.0063.00335zm9.4993 9.30934-1.3156.7206.0056.01zm-9.7273 36.5912-.693-1.3303-.0033.0017zm-34.8434 3.3058h-1.5v1.5h1.5zm0-13.185v-1.5h-1.5v1.5zm24.7362-1.6339.7033 1.3249.0059-.0032zm4.6356-4.5977-1.3277-.6979-.0034.0065zm0-13.565-1.3311.6915.0054.0104.0056.0103zm-4.6356-4.5216-.6966 1.3284.0064.0034.0064.0033zm-18.9986-1.6339v-1.5h-1.5v1.5zm0 64.3672v1.5h1.5v-1.5zm-14.9528 0v-77.81818h-3v77.81818zm-1.5-76.31818h30.7017v-3.000004h-30.7017zm30.7017 0c5.7135 0 10.4828 1.09091 14.3695 3.20012l1.4309-2.63675c-4.4221-2.399788-9.7094-3.563374-15.8004-3.563374zm14.3757 3.20349c3.909 2.09751 6.8598 4.99649 8.8929 8.70819l2.6312-1.4413c-2.3239-4.24234-5.706-7.54956-10.1057-9.91038zm8.8985 8.71819c2.0624 3.6982 3.1158 7.9997 3.1158 12.9483h3c0-5.3865-1.1506-10.2044-3.4958-14.4095zm3.1158 12.9483c0 4.9459-1.0647 9.245-3.1503 12.942l2.613 1.474c2.3728-4.2063 3.5373-9.0265 3.5373-14.416zm-3.1503 12.942c-2.0789 3.6854-5.0892 6.5632-9.0758 8.64l1.3861 2.6606c4.474-2.3308 7.9233-5.6086 10.3027-9.8266zm-9.0791 8.6417c-3.9416 2.0658-8.7814 3.1344-14.5785 3.1344v3c6.1592 0 11.5027-1.1353 15.9711-3.4772zm-14.5785 3.1344h-19.5686v3h19.5686zm-18.0686 1.5v-13.185h-3v13.185zm-1.5-11.685h16.9088v-3h-16.9088zm16.9088 0c3.3268 0 6.198-.5707 8.5307-1.809l-1.4067-2.6498c-1.771.9402-4.118 1.4588-7.124 1.4588zm8.5366-1.8122c2.3229-1.2464 4.0949-2.9898 5.2575-5.2279l-2.6622-1.3829c-.8638 1.6629-2.1823 2.9846-4.0137 3.9674zm5.2542-5.2214c1.1673-2.2207 1.7301-4.7336 1.7301-7.4995h-3c0 2.3512-.4757 4.3726-1.3856 6.1036zm1.7301-7.4995c0-2.7873-.5614-5.2951-1.7377-7.4756l-2.6403 1.4243c.9008 1.6699 1.378 3.6711 1.378 6.0513zm-1.7268-7.4549c-1.166-2.2447-2.9465-3.9686-5.2829-5.1653l-1.3676 2.6702c1.8179.9311 3.1279 2.2216 3.9883 3.878zm-5.2701-5.1586c-2.3555-1.2352-5.249-1.8055-8.6-1.8055v3c3.0325 0 5.4079.519 7.2068 1.4623zm-8.6-1.8055h-11.0952v3h11.0952zm-12.5952 1.5v64.3672h3v-64.3672zm1.5 62.8672h-16.4528v3h16.4528z"
          fill="#000"
          mask="url(#letterP-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterP-b)"
      />
    </svg>
  ),

  letterQ: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterQ-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterQ-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterQ-c"
        fill="#000"
        height="85"
        maskUnits="userSpaceOnUse"
        width="74"
        x="3"
        y="0"
      >
        <path d="m3 0h74v85h-74z" fill="#fff" />
        <path
          d="m34.5532 51.2102h13.3295l6.701 8.6208 6.5924 7.6789 12.424 15.5753h-14.6336l-8.5483-10.5042-4.3828-6.2301zm40.1697-11.3011c0 8.0895-1.5334 14.9716-4.6001 20.6463-3.0426 5.6747-7.196 10.0092-12.4602 13.0035-5.2401 2.9702-11.1321 4.4553-17.6762 4.4553-6.5923 0-12.5085-1.4972-17.7486-4.4915-5.24-2.9943-9.3814-7.3288-12.42397-13.0035-3.04261-5.6747-4.56392-12.5448-4.56392-20.6101 0-8.0895 1.52131-14.9716 4.56392-20.6463 3.04257-5.6747 7.18397-9.99718 12.42397-12.96734 5.2401-2.99433 11.1563-4.49149 17.7486-4.49149 6.5441 0 12.4361 1.49716 17.6762 4.49149 5.2642 2.97016 9.4176 7.29264 12.4602 12.96734 3.0667 5.6747 4.6001 12.5568 4.6001 20.6463zm-15.9013 0c0-5.2401-.7848-9.6591-2.3544-13.2571-1.5454-3.598-3.7308-6.3267-6.5561-8.1861s-6.1335-2.7891-9.9247-2.7891-7.0994.9297-9.9247 2.7891-5.0227 4.5881-6.5923 8.1861c-1.5455 3.598-2.3182 8.017-2.3182 13.2571 0 5.24.7727 9.6591 2.3182 13.2571 1.5696 3.598 3.767 6.3267 6.5923 8.1861 2.8253 1.8593 6.1335 2.789 9.9247 2.789s7.0994-.9297 9.9247-2.789c2.8253-1.8594 5.0107-4.5881 6.5561-8.1861 1.5696-3.598 2.3544-8.0171 2.3544-13.2571z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterQ-a)">
        <path
          d="m34.5532 51.2102h13.3295l6.701 8.6208 6.5924 7.6789 12.424 15.5753h-14.6336l-8.5483-10.5042-4.3828-6.2301zm40.1697-11.3011c0 8.0895-1.5334 14.9716-4.6001 20.6463-3.0426 5.6747-7.196 10.0092-12.4602 13.0035-5.2401 2.9702-11.1321 4.4553-17.6762 4.4553-6.5923 0-12.5085-1.4972-17.7486-4.4915-5.24-2.9943-9.3814-7.3288-12.42397-13.0035-3.04261-5.6747-4.56392-12.5448-4.56392-20.6101 0-8.0895 1.52131-14.9716 4.56392-20.6463 3.04257-5.6747 7.18397-9.99718 12.42397-12.96734 5.2401-2.99433 11.1563-4.49149 17.7486-4.49149 6.5441 0 12.4361 1.49716 17.6762 4.49149 5.2642 2.97016 9.4176 7.29264 12.4602 12.96734 3.0667 5.6747 4.6001 12.5568 4.6001 20.6463zm-15.9013 0c0-5.2401-.7848-9.6591-2.3544-13.2571-1.5454-3.598-3.7308-6.3267-6.5561-8.1861s-6.1335-2.7891-9.9247-2.7891-7.0994.9297-9.9247 2.7891-5.0227 4.5881-6.5923 8.1861c-1.5455 3.598-2.3182 8.017-2.3182 13.2571 0 5.24.7727 9.6591 2.3182 13.2571 1.5696 3.598 3.767 6.3267 6.5923 8.1861 2.8253 1.8593 6.1335 2.789 9.9247 2.789s7.0994-.9297 9.9247-2.789c2.8253-1.8594 5.0107-4.5881 6.5561-8.1861 1.5696-3.598 2.3544-8.0171 2.3544-13.2571z"
          fill={getBrandColor()}
        />
        <path
          d="m34.5532 51.2102v-1.5h-3.0201l1.8249 2.4064zm13.3295 0 1.1843-.9205-.4504-.5795h-.7339zm6.701 8.6208-1.1843.9205.0224.0288.0238.0277zm6.5924 7.6789 1.1726-.9353-.0169-.0212-.0176-.0205zm12.424 15.5753v1.5h3.1152l-1.9426-2.4354zm-14.6336 0-1.1634.9468.4502.5532h.7132zm-8.5483-10.5042-1.2268.863.0302.043.0332.0408zm-4.3828-6.2301 1.2269-.8631-.0155-.022-.0162-.0213zm24.0874-5.7955-1.3196-.7132-.0024.0044zm-12.4602 13.0036.7396 1.3049.002-.0011zm-35.4248-.0363.7442-1.3023zm-12.42397-13.0035-1.32197.7088zm0-41.2564 1.32197.7088zm12.42397-12.96734.7397 1.30495.0045-.00259zm35.4248 0-.7443 1.30238.0072.00402zm12.4602 12.96734-1.322.7088.0024.0043zm-13.6556 7.3892-1.3782.592.0034.0078zm-6.5561-8.1861-.8246 1.253zm-19.8494 0 .8246 1.253zm-6.5923 8.1861-1.3749-.5998-.0034.0078zm0 26.5142-1.3783.592.0034.0078zm6.5923 8.1861.8246-1.253zm19.8494 0-.8246-1.253zm6.5561-8.1861-1.3748-.5998-.0034.0078zm-21.914-.456h13.3295v-3h-13.3295zm12.1452-.5794 6.701 8.6207 2.3686-1.8411-6.701-8.6207zm6.7472 8.6772 6.5923 7.679 2.2763-1.9541-6.5924-7.679zm6.5578 7.6373 12.424 15.5753 2.3453-1.8708-12.424-15.5752zm13.5967 13.1399h-14.6336v3h14.6336zm-13.4701.5532-8.5483-10.5042-2.3269 1.8936 8.5483 10.5042zm-8.4849-10.4205-4.3828-6.2301-2.4537 1.7261 4.3828 6.2301zm-4.4145-6.2734-11.4822-15.1407-2.3904 1.8128 11.4822 15.1406zm25.9923-25.5354c0 7.9026-1.4977 14.5263-4.4197 19.9331l2.6392 1.4264c3.2115-5.9426 4.7805-13.0831 4.7805-21.3595zm-4.4221 19.9375c-2.9179 5.4421-6.877 9.5629-11.8799 12.4085l1.4833 2.6077c5.5256-3.143 9.8732-7.6913 13.0406-13.5986zm-11.8779 12.4074c-4.9953 2.8314-10.6286 4.2602-16.9365 4.2602v3c6.7803 0 12.931-1.5414 18.4158-4.6503zm-16.9365 4.2602c-6.356 0-12.0115-1.4408-17.0044-4.2938l-1.4884 2.6047c5.4873 3.1356 11.6642 4.6891 18.4928 4.6891zm-17.0044-4.2938c-4.979-2.8452-8.9274-6.9661-11.8462-12.41l-2.64394 1.4176c3.16634 5.9055 7.50074 10.4536 13.00174 13.5971zm-11.8462-12.41c-2.89984-5.4085-4.38589-12.022-4.38589-19.9013h-3c0 8.2513 1.55657 15.3779 4.74195 21.3189zm-4.38589-19.9013c0-7.9043 1.48636-14.5297 4.38589-19.9375l-2.64394-1.4176c-3.1857 5.9416-4.74195 13.0804-4.74195 21.3551zm4.38589-19.9375c2.9184-5.443 6.8653-9.5505 11.8417-12.3712l-1.4793-2.60989c-5.5038 3.11963-9.8395 7.65699-13.00634 13.56349zm11.8462-12.37378c4.9929-2.85305 10.6484-4.29385 17.0044-4.29385v-2.999996c-6.8286 0-13.0055 1.553526-18.4928 4.689116zm17.0044-4.29385c6.3057 0 11.9374 1.43985 16.9319 4.29385l1.4885-2.60473c-5.4856-3.13464-11.638-4.689116-18.4204-4.689116zm16.9391 4.29789c5.0001 2.82114 8.9579 6.92854 11.8753 12.36974l2.644-1.4176c-3.1679-5.9082-7.5169-10.4458-13.0451-13.56495zm11.8777 12.37404c2.922 5.4069 4.4197 12.0306 4.4197 19.9332h3c0-8.2764-1.569-15.4169-4.7805-21.3595zm-8.4816 19.9332c0-5.381-.8047-10.0177-2.4795-13.8569l-2.7497 1.1996c1.4644 3.3568 2.2292 7.5582 2.2292 12.6573zm-2.4761-13.8491c-1.6426-3.8242-4.0023-6.802-7.1097-8.8471l-1.6493 2.506c2.5432 1.6737 4.5542 4.1532 6.0025 7.5251zm-7.1097-8.8471c-3.0991-2.0395-6.7018-3.0361-10.7494-3.0361v3c3.5348 0 6.5486.8629 9.1001 2.5421zm-10.7494-3.0361c-4.0476 0-7.6503.9966-10.7493 3.0361l1.6492 2.506c2.5515-1.6792 5.5654-2.5421 9.1001-2.5421zm-10.7493 3.0361c-3.1052 2.0436-5.4759 5.0186-7.1426 8.8393l2.7497 1.1996c1.4725-3.3754 3.4967-5.8577 6.0421-7.5329zm-7.146 8.8471c-1.648 3.8368-2.4399 8.4706-2.4399 13.8491h3c0-5.1016.7535-9.3059 2.1964-12.6651zm-2.4399 13.8491c0 5.3785.7919 10.0123 2.4399 13.8491l2.7565-1.184c-1.4429-3.3592-2.1964-7.5635-2.1964-12.6651zm2.4433 13.8569c1.6667 3.8207 4.0374 6.7957 7.1426 8.8393l1.6492-2.506c-2.5454-1.6752-4.5696-4.1576-6.0421-7.5329zm7.1426 8.8393c3.099 2.0395 6.7017 3.036 10.7493 3.036v-3c-3.5347 0-6.5486-.8628-9.1001-2.542zm10.7493 3.036c4.0476 0 7.6503-.9965 10.7494-3.036l-1.6493-2.506c-2.5515 1.6792-5.5653 2.542-9.1001 2.542zm10.7494-3.036c3.1074-2.0451 5.4671-5.023 7.1097-8.8471l-2.7565-1.184c-1.4483 3.3719-3.4593 5.8514-6.0025 7.5251zm7.1063-8.8393c1.6748-3.8392 2.4795-8.4759 2.4795-13.8569h-3c0 5.0991-.7648 9.3005-2.2292 12.6573z"
          fill="#000"
          mask="url(#letterQ-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterQ-b)"
      />
    </svg>
  ),

  letterR: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterR-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterR-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterR-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="67"
        x="10"
        y="-1"
      >
        <path d="m10-1h67v82h-67z" fill="#fff" />
        <path
          d="m12.1541 79v-77.81818h30.7017c5.8769 0 10.8925 1.05125 15.0469 3.15376 4.1797 2.07718 7.3588 5.02829 9.5373 8.85332 2.2038 3.7997 3.3057 8.2707 3.3057 13.413 0 5.1676-1.1145 9.6133-3.3437 13.337-2.2292 3.6984-5.4589 6.5355-9.6893 8.5114-4.205 1.9758-9.2966 2.9638-15.2748 2.9638h-20.5565v-13.2231h17.8967c3.1411 0 5.7502-.4306 7.8274-1.2919 2.0771-.8612 3.6224-2.1531 4.6356-3.8757 1.0386-1.7225 1.5579-3.863 1.5579-6.4215 0-2.5838-.5193-4.7623-1.5579-6.5355-1.0132-1.7732-2.5711-3.1158-4.6736-4.0277-2.0772-.9373-4.699-1.4059-7.8654-1.4059h-11.0952v64.3672zm42.0249-35.4134 19.3405 35.4134h-18.1626l-18.9226-35.4134z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterR-a)">
        <path
          d="m12.1541 79v-77.81818h30.7017c5.8769 0 10.8925 1.05125 15.0469 3.15376 4.1797 2.07718 7.3588 5.02829 9.5373 8.85332 2.2038 3.7997 3.3057 8.2707 3.3057 13.413 0 5.1676-1.1145 9.6133-3.3437 13.337-2.2292 3.6984-5.4589 6.5355-9.6893 8.5114-4.205 1.9758-9.2966 2.9638-15.2748 2.9638h-20.5565v-13.2231h17.8967c3.1411 0 5.7502-.4306 7.8274-1.2919 2.0771-.8612 3.6224-2.1531 4.6356-3.8757 1.0386-1.7225 1.5579-3.863 1.5579-6.4215 0-2.5838-.5193-4.7623-1.5579-6.5355-1.0132-1.7732-2.5711-3.1158-4.6736-4.0277-2.0772-.9373-4.699-1.4059-7.8654-1.4059h-11.0952v64.3672zm42.0249-35.4134 19.3405 35.4134h-18.1626l-18.9226-35.4134z"
          fill={getBrandColor()}
        />
        <path
          d="m12.1541 79h-1.5v1.5h1.5zm0-77.81818v-1.500004h-1.5v1.500004zm45.7486 3.15376-.6774 1.3384.0098.00487zm9.5373 8.85332-1.3035.7424.0059.0102zm-.038 26.75 1.2847.7744.0023-.0039zm-9.6893 8.5114-.6348-1.3591-.0031.0015zm-35.8313 2.9638h-1.5v1.5h1.5zm0-13.2231v-1.5h-1.5v1.5zm25.7241-1.2919.5745 1.3857zm4.6356-3.8757-1.2845-.7745-.0042.007-.0042.007zm0-12.957-1.3023.7442.0039.007.0041.0069zm-4.6736-4.0277-.617 1.3673.01.0045.0101.0043zm-18.9606-1.4059v-1.5h-1.5v1.5zm0 64.3672v1.5h1.5v-1.5zm25.5721-35.4134 1.3164-.7189-.4265-.7811h-.8899zm19.3405 35.4134v1.5h2.5284l-1.2119-2.219zm-18.1626 0-1.323.7069.4238.7931h.8992zm-18.9226-35.4134v-1.5h-2.5022l1.1792 2.207zm-22.7802 35.4134v-77.81818h-3v77.81818zm-1.5-76.31818h30.7017v-3.000004h-30.7017zm30.7017 0c5.7017 0 10.473 1.02006 14.3696 2.99212l1.3546-2.67672c-4.4121-2.232961-9.6721-3.315404-15.7242-3.315404zm14.3793 2.99703c3.9297 1.95293 6.8796 4.70235 8.9015 8.25245l2.6068-1.4847c-2.3351-4.10009-5.7434-7.25286-10.1731-9.45428zm8.9073 8.26265c2.0502 3.5347 3.1033 7.7369 3.1033 12.6604h3c0-5.3611-1.1506-10.1008-3.5082-14.1656zm3.1033 12.6604c0 4.9484-1.0655 9.1166-3.1307 12.5666l2.574 1.5409c2.3931-3.9975 3.5567-8.7206 3.5567-14.1075zm-3.1284 12.5627c-2.0628 3.4224-5.0559 6.0661-9.0394 7.9266l1.2696 2.7181c4.4773-2.0911 7.9437-5.1217 10.3392-9.0961zm-9.0425 7.9281c-3.9568 1.8592-8.8183 2.8214-14.6369 2.8214v3c6.1378 0 11.4595-1.0137 15.9127-3.1062zm-14.6369 2.8214h-20.5565v3h20.5565zm-19.0565 1.5v-13.2231h-3v13.2231zm-1.5-11.7231h17.8967v-3h-17.8967zm17.8967 0c3.2655 0 6.0857-.4458 8.4019-1.4062l-1.1491-2.7713c-1.8381.7622-4.2362 1.1775-7.2528 1.1775zm8.4019-1.4062c2.3386-.9697 4.1551-2.4627 5.354-4.5008l-2.5858-1.5211c-.8276 1.4069-2.1015 2.4978-3.9173 3.2506zm5.3457-4.4868c1.2131-2.012 1.7733-4.4379 1.7733-7.1961h-3c0 2.3587-.4783 4.2139-1.3424 5.647zm1.7733-7.1961c0-2.7826-.5597-5.2383-1.7636-7.2936l-2.5886 1.5162c.8734 1.4911 1.3522 3.3924 1.3522 5.7774zm-1.7555-7.2797c-1.1935-2.0885-3.0175-3.6353-5.3792-4.6596l-1.1937 2.7522c1.8434.7996 3.1351 1.9379 3.9682 3.3958zm-5.3591-4.6508c-2.3311-1.0518-5.1807-1.5386-8.4823-1.5386v3c3.0312 0 5.4252.4505 7.2484 1.2732zm-8.4823-1.5386h-11.0952v3h11.0952zm-12.5952 1.5v64.3672h3v-64.3672zm1.5 62.8672h-16.4528v3h16.4528zm24.2556-33.1944 19.3406 35.4134 2.6329-1.438-19.3406-35.4133zm20.657 33.1944h-18.1626v3h18.1626zm-16.8396.7931-18.9226-35.4134-2.646 1.4139 18.9226 35.4133zm-20.2456-33.2065h17.7447v-3h-17.7447z"
          fill="#000"
          mask="url(#letterR-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterR-b)"
      />
    </svg>
  ),

  letterS: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterS-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterS-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterS-c"
        fill="#000"
        height="80"
        maskUnits="userSpaceOnUse"
        width="63"
        x="9"
        y="0"
      >
        <path d="m9 0h63v80h-63z" fill="#fff" />
        <path
          d="m53.7707 24.1527c-.2898-2.9219-1.5334-5.1918-3.7308-6.8097-2.1975-1.6179-5.1797-2.4268-8.9468-2.4268-2.5596 0-4.7209.3622-6.4836 1.0866-1.7628.7003-3.1151 1.6783-4.0569 2.934-.9176 1.2557-1.3764 2.6804-1.3764 4.2741-.0483 1.3282.2294 2.4873.8331 3.4773.6279.9901 1.4851 1.8473 2.5718 2.5717 1.0866.7003 2.3423 1.3161 3.767 1.8473 1.4247.5071 2.946.9418 4.5639 1.304l6.6648 1.5938c3.2358.7244 6.206 1.6903 8.9105 2.8977 2.7046 1.2074 5.0469 2.6925 7.027 4.4553 1.9801 1.7627 3.5135 3.8394 4.6001 6.2301 1.1108 2.3906 1.6783 5.1314 1.7024 8.2223-.0241 4.5397-1.1832 8.4758-3.4772 11.8082-2.2699 3.3082-5.554 5.88-9.8523 7.7152-4.2741 1.8111-9.4297 2.7166-15.4666 2.7166-5.9887 0-11.2046-.9176-15.6477-2.7528-4.4191-1.8352-7.8722-4.5519-10.3594-8.1499-2.4631-3.6221-3.755-8.1015-3.8757-13.4382h15.1768c.1691 2.4872.8814 4.5639 2.1371 6.2301 1.2798 1.6421 2.9822 2.8857 5.1072 3.7309 2.1492.821 4.576 1.2315 7.2806 1.2315 2.6562 0 4.9623-.3864 6.9183-1.1591 1.9801-.7727 3.5135-1.8473 4.6001-3.2237 1.0867-1.3764 1.63-2.9581 1.63-4.7451 0-1.6661-.495-3.0667-1.4851-4.2017-.9659-1.1349-2.3906-2.1008-4.2741-2.8977-1.8594-.7969-4.1414-1.5213-6.8459-2.1733l-8.0774-2.0284c-6.2543-1.5213-11.1925-3.8998-14.8146-7.1356-3.6222-3.2358-5.4212-7.5945-5.3971-13.076-.0241-4.4915 1.1712-8.4155 3.586-11.7721 2.4389-3.35649 5.7834-5.97652 10.0334-7.86004s9.0795-2.82529 14.4886-2.82529c5.5057 0 10.3111.94177 14.4162 2.82529 4.1293 1.88352 7.3409 4.50355 9.6349 7.86004 2.2941 3.3566 3.4773 7.2444 3.5497 11.6634z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterS-a)">
        <path
          d="m53.7707 24.1527c-.2898-2.9219-1.5334-5.1918-3.7308-6.8097-2.1975-1.6179-5.1797-2.4268-8.9468-2.4268-2.5596 0-4.7209.3622-6.4836 1.0866-1.7628.7003-3.1151 1.6783-4.0569 2.934-.9176 1.2557-1.3764 2.6804-1.3764 4.2741-.0483 1.3282.2294 2.4873.8331 3.4773.6279.9901 1.4851 1.8473 2.5718 2.5717 1.0866.7003 2.3423 1.3161 3.767 1.8473 1.4247.5071 2.946.9418 4.5639 1.304l6.6648 1.5938c3.2358.7244 6.206 1.6903 8.9105 2.8977 2.7046 1.2074 5.0469 2.6925 7.027 4.4553 1.9801 1.7627 3.5135 3.8394 4.6001 6.2301 1.1108 2.3906 1.6783 5.1314 1.7024 8.2223-.0241 4.5397-1.1832 8.4758-3.4772 11.8082-2.2699 3.3082-5.554 5.88-9.8523 7.7152-4.2741 1.8111-9.4297 2.7166-15.4666 2.7166-5.9887 0-11.2046-.9176-15.6477-2.7528-4.4191-1.8352-7.8722-4.5519-10.3594-8.1499-2.4631-3.6221-3.755-8.1015-3.8757-13.4382h15.1768c.1691 2.4872.8814 4.5639 2.1371 6.2301 1.2798 1.6421 2.9822 2.8857 5.1072 3.7309 2.1492.821 4.576 1.2315 7.2806 1.2315 2.6562 0 4.9623-.3864 6.9183-1.1591 1.9801-.7727 3.5135-1.8473 4.6001-3.2237 1.0867-1.3764 1.63-2.9581 1.63-4.7451 0-1.6661-.495-3.0667-1.4851-4.2017-.9659-1.1349-2.3906-2.1008-4.2741-2.8977-1.8594-.7969-4.1414-1.5213-6.8459-2.1733l-8.0774-2.0284c-6.2543-1.5213-11.1925-3.8998-14.8146-7.1356-3.6222-3.2358-5.4212-7.5945-5.3971-13.076-.0241-4.4915 1.1712-8.4155 3.586-11.7721 2.4389-3.35649 5.7834-5.97652 10.0334-7.86004s9.0795-2.82529 14.4886-2.82529c5.5057 0 10.3111.94177 14.4162 2.82529 4.1293 1.88352 7.3409 4.50355 9.6349 7.86004 2.2941 3.3566 3.4773 7.2444 3.5497 11.6634z"
          fill={getBrandColor()}
        />
        <path
          d="m53.7707 24.1527-1.4927.148.1341 1.352h1.3586zm-19.1612-8.1499.5538 1.3941.0082-.0033.0081-.0034zm-4.0569 2.934-1.2-.9-.0055.0074-.0055.0076zm-1.3764 4.2741 1.499.0545.001-.0272v-.0273zm.8331 3.4773-1.2807.7809.0069.0113.0071.0111zm2.5718 2.5717-.8321 1.2481.0097.0065.0098.0063zm3.767 1.8473-.5241 1.4055.0105.0039.0106.0038zm4.5639 1.304.3489-1.4588-.0106-.0026-.0106-.0023zm6.6648 1.5938-.3489 1.4588.0106.0026.0106.0023zm8.9105 2.8977-.6115 1.3697zm7.027 4.4553.9974-1.1204zm4.6001 6.2301-1.3656.6207.0053.0113zm1.7024 8.2223 1.5.0079.0001-.0098-.0001-.0098zm-3.4772 11.8082-1.2356-.8505-.0013.0019zm-9.8523 7.7152.5852 1.3811.0038-.0016zm-31.1143-.0362-.5754 1.3853.0027.0011zm-10.3594-8.1499-1.2404.8435.0065.0095zm-3.8757-13.4382v-1.5h-1.53435l.03471 1.5339zm15.1768 0 1.4966-.1017-.0951-1.3983h-1.4015zm2.1371 6.2301-1.1979.9028.0073.0097.0075.0096zm5.1072 3.7309-.5543 1.3938.0095.0037.0095.0037zm14.1989.0724-.5453-1.3974-.0058.0023zm4.6001-3.2237 1.1774.9294zm.1449-8.9468-1.1423.9722.006.007.006.0069zm-4.2741-2.8977-.5909 1.3787.0064.0028zm-6.8459-2.1733-.3653 1.4548.0069.0018.0069.0016zm-8.0774-2.0284.3653-1.4549-.0108-.0026zm-14.8146-7.1356-.9994 1.1186zm-5.3971-13.076 1.5.0066.0001-.0074-.0001-.0073zm3.586-11.7721-1.2135-.8817-.0042.0058zm38.9382-7.86004-.6255 1.36335.003.00138zm9.6349 7.86004-1.2384.8464zm3.5497 11.6634v1.5h1.5248l-.025-1.5246zm-13.5392-.148c-.3282-3.3086-1.7664-5.979-4.3342-7.8696l-1.7787 2.4159c1.8271 1.3452 2.8761 3.2145 3.1275 5.7497zm-4.3342-7.8696c-2.5369-1.8678-5.8682-2.7189-9.8361-2.7189v3c3.5662 0 6.1994.7668 8.0574 2.1348zm-9.8361-2.7189c-2.692 0-5.0596.3797-7.0538 1.1992l1.1403 2.7748c1.5314-.6293 3.4862-.974 5.9135-.974zm-7.0374 1.1926c-1.9659.781-3.5639 1.9092-4.7031 3.428l2.4 1.8c.7444-.9925 1.8509-1.8203 3.4107-2.4399zm-4.7141 3.443c-1.1103 1.5193-1.6654 3.2557-1.6654 5.1591h3c0-1.284.3626-2.397 1.0875-3.3891zm-1.6644 5.1046c-.0574 1.5779.2732 3.0364 1.0514 4.3127l2.5614-1.5618c-.4291-.7038-.654-1.5634-.6148-2.6419zm1.0654 4.3351c.7522 1.1863 1.7653 2.1891 3.0064 3.0165l1.6641-2.4961c-.9322-.6215-1.6336-1.3331-2.137-2.127zm3.0259 3.0293c1.1915.7679 2.5469 1.4294 4.0555 1.9919l1.0482-2.8109c-1.3408-.5-2.4968-1.07-3.4786-1.7027zm4.0766 1.9996c1.4872.5293 3.0675.9803 4.7392 1.3546l.6554-2.9275c-1.5641-.3502-3.0264-.7686-4.3886-1.2534zm4.7181 1.3497 6.6647 1.5937.6978-2.9177-6.6648-1.5937zm6.6859 1.5986c3.1497.7052 6.0235 1.6415 8.6267 2.8037l1.223-2.7394c-2.8059-1.2526-5.8724-2.2481-9.1943-2.9918zm8.6267 2.8037c2.5802 1.1519 4.7887 2.5568 6.6411 4.2059l1.9948-2.2407c-2.1078-1.8765-4.584-3.4417-7.4129-4.7046zm6.6411 4.2059c1.8254 1.6251 3.2327 3.5321 4.232 5.7305l2.7311-1.2414c-1.1741-2.5829-2.8335-4.8293-4.9683-6.7298zm4.2372 5.7418c1.0062 2.1655 1.54 4.6888 1.5628 7.602l2.9999-.0234c-.0255-3.2687-.6266-6.2269-1.842-8.8427zm1.5628 7.5823c-.0228 4.2769-1.11 7.9109-3.2129 10.9657l2.4711 1.7011c2.4852-3.6101 3.7162-7.8482 3.7417-12.6509zm-3.2142 10.9676c-2.0836 3.0367-5.1241 5.4421-9.2044 7.1843l1.178 2.759c4.5163-1.9283 8.044-4.6663 10.5001-8.246zm-9.2006 7.1827c-4.0424 1.7129-8.9879 2.5977-14.8814 2.5977v3c6.1803 0 11.546-.9262 16.0518-2.8355zm-14.8814 2.5977c-5.8388 0-10.8522-.895-15.0751-2.6392l-1.1453 2.7728c4.6635 1.9262 10.0819 2.8664 16.2204 2.8664zm-15.0724-2.6381c-4.179-1.7355-7.3928-4.2787-9.7008-7.6175l-2.4678 1.7059c2.6664 3.8571 6.3588 6.7472 11.0179 8.6822zm-9.6943-7.608c-2.268-3.3353-3.5009-7.5176-3.6165-12.6287l-2.99924.0678c.12584 5.5622 1.47674 10.3387 4.13494 14.2478zm-5.1161-11.0948h15.1768v-3h-15.1768zm13.6803-1.3983c.1848 2.7202.9732 5.0906 2.4357 7.0312l2.3958-1.8055c-1.0489-1.3918-1.6852-3.1748-1.8384-5.4291zm2.4505 7.0505c1.4596 1.8727 3.3883 3.2688 5.736 4.2026l1.1087-2.7877c-1.9023-.7566-3.3785-1.8477-4.4785-3.2591zm5.755 4.21c2.3472.8967 4.9599 1.3303 7.8159 1.3303v-3c-2.5531 0-4.7942-.3874-6.7453-1.1328zm7.8159 1.3303c2.7972 0 5.2985-.4064 7.4694-1.264l-1.1022-2.7902c-1.7411.6878-3.852 1.0542-6.3672 1.0542zm7.4636-1.2617c2.176-.8492 3.9484-2.0655 5.2322-3.6917l-2.3547-1.8589c-.8895 1.1267-2.1839 2.0595-3.9681 2.7558zm5.2322-3.6917c1.2999-1.6465 1.9526-3.5572 1.9526-5.6745h-3c0 1.4566-.4339 2.7093-1.3073 3.8156zm1.9526-5.6745c0-1.9873-.6004-3.7499-1.8547-5.1877l-2.2607 1.9721c.7258.832 1.1154 1.8706 1.1154 3.2156zm-1.8428-5.1738c-1.163-1.3666-2.809-2.4512-4.832-3.307l-1.1689 2.7629c1.7441.7379 2.9476 1.5851 3.7163 2.4884zm-4.8255-3.3043c-1.9595-.8398-4.3269-1.5878-7.0853-2.2528l-.703 2.9164c2.6507.6391 4.8472 1.3398 6.6065 2.0938zm-7.0715-2.2494-8.0774-2.0284-.7307 2.9096 8.0775 2.0284zm-8.0882-2.0311c-6.0897-1.4813-10.7815-3.7699-14.1698-6.7968l-1.9987 2.2373c3.8561 3.4447 9.0407 5.9132 15.4595 7.4745zm-14.1698-6.7968c-3.2588-2.9111-4.9189-6.8372-4.8964-11.9507l-2.9999-.0132c-.0258 5.8495 1.9121 10.6408 5.8976 14.2012zm-4.8964-11.9654c-.0226-4.2032 1.0902-7.8113 3.3036-10.888l-2.4353-1.7519c-2.6161 3.6364-3.8939 7.8763-3.8682 12.656zm3.2995-10.8822c2.2655-3.118 5.3894-5.58081 9.4276-7.37048l-1.2155-2.74272c-4.4618 1.97738-8.0269 4.75463-10.6391 8.3497zm9.4276-7.37048c4.0299-1.78595 8.6472-2.69665 13.8809-2.69665v-2.999996c-5.5845 0-10.6262.972826-15.0964 2.953926zm13.8809-2.69665c5.3361 0 9.9199.91265 13.7907 2.68863l1.251-2.72668c-4.3395-1.99106-9.3664-2.961946-15.0417-2.961946zm13.7937 2.69002c3.9103 1.78364 6.8967 4.23641 9.019 7.34171l2.4768-1.6927c-2.4657-3.60776-5.9026-6.39506-10.2508-8.37847zm9.019 7.34171c2.1139 3.093 3.2203 6.6895 3.2883 10.8416l2.9996-.0492c-.0768-4.6859-1.3369-8.865-3.8111-12.4851zm4.7881 9.317h-15.0319v3h15.0319z"
          fill="#000"
          mask="url(#letterS-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterS-b)"
      />
    </svg>
  ),

  letterT: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterT-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterT-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterT-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="68"
        x="6"
        y="-1"
      >
        <path d="m6-1h68v82h-68z" fill="#fff" />
        <path
          d="m8.06339 14.7468v-13.56498h63.91121v13.56498h-23.8242v64.2532h-16.2628v-64.2532z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterT-a)">
        <path
          d="m8.06339 14.7468v-13.56498h63.91121v13.56498h-23.8242v64.2532h-16.2628v-64.2532z"
          fill={getBrandColor()}
        />
        <path
          d="m8.06339 14.7468h-1.5v1.5h1.5zm0-13.56498v-1.500004h-1.5v1.500004zm63.91121 0h1.5v-1.500004h-1.5zm0 13.56498v1.5h1.5v-1.5zm-23.8242 0v-1.5h-1.5v1.5zm0 64.2532v1.5h1.5v-1.5zm-16.2628 0h-1.5v1.5h1.5zm0-64.2532h1.5v-1.5h-1.5zm-22.32421 0v-13.56498h-3v13.56498zm-1.5-12.06498h63.91121v-3.000004h-63.91121zm62.41121-1.5v13.56498h3v-13.56498zm1.5 12.06498h-23.8242v3h23.8242zm-25.3242 1.5v64.2532h3v-64.2532zm1.5 62.7532h-16.2628v3h16.2628zm-14.7628 1.5v-64.2532h-3v64.2532zm-1.5-65.7532h-23.82421v3h23.82421z"
          fill="#000"
          mask="url(#letterT-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterT-b)"
      />
    </svg>
  ),

  letterU: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterU-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterU-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterU-c"
        fill="#000"
        height="81"
        maskUnits="userSpaceOnUse"
        width="66"
        x="7"
        y="-1"
      >
        <path d="m7-1h66v81h-66z" fill="#fff" />
        <path
          d="m55.359 1.36363h15.9915v49.11937c0 5.5151-1.3172 10.3409-3.9517 14.4772-2.6099 4.1364-6.2661 7.3618-10.9688 9.6762-4.7026 2.2897-10.1808 3.4346-16.4346 3.4346-6.2784 0-11.769-1.1449-16.4716-3.4346-4.7027-2.3144-8.3589-5.5398-10.9688-9.6762-2.60981-4.1363-3.91473-8.9621-3.91473-14.4772v-49.11937h15.99143v47.75287c0 2.8807.6279 5.4413 1.8836 7.6818 1.2803 2.2405 3.0776 4.0009 5.392 5.2812s5.0104 1.9205 8.0881 1.9205c3.1023 0 5.7983-.6402 8.0881-1.9205 2.3143-1.2803 4.0994-3.0407 5.3551-5.2812 1.2803-2.2405 1.9204-4.8011 1.9204-7.6818z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterU-a)">
        <path
          d="m55.359 1.36363h15.9915v49.11937c0 5.5151-1.3172 10.3409-3.9517 14.4772-2.6099 4.1364-6.2661 7.3618-10.9688 9.6762-4.7026 2.2897-10.1808 3.4346-16.4346 3.4346-6.2784 0-11.769-1.1449-16.4716-3.4346-4.7027-2.3144-8.3589-5.5398-10.9688-9.6762-2.60981-4.1363-3.91473-8.9621-3.91473-14.4772v-49.11937h15.99143v47.75287c0 2.8807.6279 5.4413 1.8836 7.6818 1.2803 2.2405 3.0776 4.0009 5.392 5.2812s5.0104 1.9205 8.0881 1.9205c3.1023 0 5.7983-.6402 8.0881-1.9205 2.3143-1.2803 4.0994-3.0407 5.3551-5.2812 1.2803-2.2405 1.9204-4.8011 1.9204-7.6818z"
          fill={getBrandColor()}
        />
        <path
          d="m55.359 1.36363v-1.499996h-1.5v1.499996zm15.9915 0h1.5v-1.499996h-1.5zm-3.9517 63.59657-1.2652-.8058-.0034.0054zm-10.9688 9.6762.6567 1.3486.0057-.0028zm-32.9062 0-.6624 1.3458.0057.0028zm-10.9688-9.6762-1.2685.8005zm-3.91473-63.59657v-1.499996h-1.5v1.499996zm15.99143 0h1.5v-1.499996h-1.5zm1.8836 55.43467-1.3086.7334.0062.0108zm5.392 5.2812-.7261 1.3126zm16.1762 0-.7261-1.3125-.006.0033zm5.3551-5.2812-1.3024-.7442-.0061.0108zm1.9204-53.93467h15.9915v-2.999996h-15.9915zm14.4915-1.5v49.11937h3v-49.11937zm0 49.11937c0 5.2663-1.2543 9.805-3.7169 13.6714l2.5304 1.6116c2.8064-4.4063 4.1865-9.5191 4.1865-15.283zm-3.7203 13.6768c-2.4514 3.8852-5.8899 6.9295-10.3625 9.1307l1.3247 2.6917c4.9327-2.4276 8.8067-5.834 11.575-10.2215zm-10.3568 9.1279c-4.4619 2.1726-9.7077 3.2833-15.778 3.2833v3c6.4373 0 12.1479-1.179 17.0913-3.586zm-15.778 3.2833c-6.0959 0-11.3538-1.1111-15.8149-3.2833l-1.3134 2.6973c4.9442 2.4074 10.6674 3.586 17.1283 3.586zm-15.8093-3.2805c-4.4726-2.2012-7.9111-5.2455-10.3625-9.1307l-2.5371 1.6009c2.7683 4.3875 6.6422 7.7939 11.5749 10.2215zm-10.3625-9.1307c-2.44-3.8671-3.6833-8.4078-3.6833-13.6768h-3.00003c0 5.7612 1.36647 10.8721 4.14623 15.2777zm-3.6833-13.6768v-49.11937h-3.00003v49.11937zm-1.50003-47.61937h15.99143v-2.999996h-15.99143zm14.49143-1.5v47.75287h3v-47.75287zm0 47.75287c0 3.1057.6791 5.9244 2.0751 8.4151l2.617-1.4667c-1.1155-1.9902-1.6921-4.2927-1.6921-6.9484zm2.0812 8.426c1.4202 2.4854 3.4197 4.4397 5.9683 5.8496l1.4522-2.6251c-2.0802-1.1507-3.6754-2.7172-4.8158-4.7129zm5.9683 5.8496c2.5706 1.422 5.5244 2.1079 8.8142 2.1079v-3c-2.8655 0-5.3038-.5944-7.362-1.733zm8.8142 2.1079c3.3116 0 6.269-.6848 8.8201-2.1112l-1.4641-2.6185c-2.0284 1.1342-4.4631 1.7297-7.356 1.7297zm8.8141-2.1079c2.551-1.4112 4.5412-3.3689 5.9376-5.8605l-2.617-1.4667c-1.115 1.9896-2.6949 3.5527-4.7727 4.7021zm5.9314-5.8496c1.4244-2.4927 2.1181-5.3153 2.1181-8.426h-3c0 2.6507-.5866 4.9492-1.7228 6.9376zm2.1181-8.426v-47.75287h-3v47.75287z"
          fill="#000"
          mask="url(#letterU-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterU-b)"
      />
    </svg>
  ),

  letterV: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterV-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterV-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterV-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="81"
        x="0"
        y="-1"
      >
        <path d="m0-1h81v82h-81z" fill="#fff" />
        <path
          d="m21.3019 1.18182 18.8086 59.12358h.722l18.8466-59.12358h18.2386l-26.826 77.81818h-21.2024l-26.864-77.81818z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterV-a)">
        <path
          d="m21.3019 1.18182 18.8086 59.12358h.722l18.8466-59.12358h18.2386l-26.826 77.81818h-21.2024l-26.864-77.81818z"
          fill={getBrandColor()}
        />
        <path
          d="m21.3019 1.18182 1.4294-.454734-.3325-1.04527h-1.0969zm18.8086 59.12358-1.4294.4547.3325 1.0453h1.0969zm.722 0v1.5h1.0962l.3329-1.0444zm18.8466-59.12358v-1.500004h-1.0962l-.333 1.044437zm18.2386 0 1.4181.48885.6856-1.988854h-2.1037zm-26.826 77.81818v1.5h1.0695l.3486-1.0111zm-21.2024 0-1.4179.4895.3489 1.0105h1.069zm-26.864-77.81818v-1.500004h-2.104685l.686795 1.989474zm16.8472.45473 18.8086 59.12355 2.8588-.9094-18.8086-59.123614zm20.238 60.16885h.722v-3h-.722zm2.1511-1.0444 18.8466-59.12362-2.8583-.911127-18.8466 59.123547zm17.4175-58.07918h18.2386v-3.000004h-18.2386zm16.8205-1.988862-26.826 77.818142 2.8362.9778 26.826-77.81823zm-25.4079 76.807042h-21.2024v3h21.2024zm-19.7845 1.0105-26.86401-77.818161-2.83578.978951 26.86399 77.81821zm-28.2819-75.82868h18.2766v-3.000004h-18.2766z"
          fill="#000"
          mask="url(#letterV-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterV-b)"
      />
    </svg>
  ),

  letterW: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterW-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterW-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterW-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="111"
        x="-15"
        y="-1"
      >
        <path d="m-15-1h111v82h-111z" fill="#fff" />
        <path
          d="m9.34708 79-22.26638-77.81818h17.9727l12.881 54.06998h.646l14.2109-54.06998h15.3889l14.1729 54.18398h.684l12.881-54.18398h17.9727l-22.2664 77.81818h-16.0348l-14.8189-50.8782h-.6079l-14.7809 50.8782z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterW-a)">
        <path
          d="m9.34708 79-22.26638-77.81818h17.9727l12.881 54.06998h.646l14.2109-54.06998h15.3889l14.1729 54.18398h.684l12.881-54.18398h17.9727l-22.2664 77.81818h-16.0348l-14.8189-50.8782h-.6079l-14.7809 50.8782z"
          fill={getBrandColor()}
        />
        <path
          d="m9.34708 79-1.44213.4126.31113 1.0874h1.131zm-22.26638-77.81818v-1.500004h-1.9894l.5473 1.912644zm17.9727 0 1.45917-.34762-.27453-1.152384h-1.18464zm12.881 54.06998-1.4591.3476.2745 1.1524h1.1846zm.646 0v1.5h1.1567l.294-1.1187zm14.2109-54.06998v-1.500004h-1.1567l-.294 1.118712zm15.3889 0 1.4512-.37959-.2931-1.120414h-1.1581zm14.1729 54.18398-1.4512.3796.2931 1.1204h1.1581zm.684 0v1.5h1.1852l.2741-1.1531zm12.881-54.18398v-1.500004h-1.1852l-.2741 1.153076zm17.9727 0 1.4421.41264.5473-1.912644h-1.9894zm-22.2664 77.81818v1.5h1.131l.3112-1.0874zm-16.0348 0-1.4401.4195.3147 1.0805h1.1254zm-14.8189-50.8782 1.4402-.4195-.3147-1.0805h-1.1255zm-.6079 0v-1.5h-1.1263l-.3142 1.0815zm-14.7809 50.8782v1.5h1.1262l.3142-1.0815zm-14.5927-.4126-22.2663-77.818224-2.8843.825284 22.26635 77.81814zm-23.7085-75.90558h17.9727v-3.000004h-17.9727zm16.51354-1.15239 12.88106 54.06997 2.9183-.6952-12.88103-54.07zm14.34016 55.22237h.646v-3h-.646zm2.0967-1.1187 14.211-54.07-2.9015-.762572-14.2109 54.069972zm12.7602-52.95128h15.3889v-3.000004h-15.3889zm13.9377-1.12042 14.1729 54.184 2.9024-.7592-14.1729-54.18397zm15.6241 55.3044h.684v-3h-.684zm2.1433-1.1531 12.881-54.18396-2.9186-.693848-12.8811 54.183908zm11.4217-53.03088h17.9727v-3.000004h-17.9727zm16.5305-1.912644-22.2663 77.818224 2.8843.8252 22.2663-77.81814zm-20.8242 76.730824h-16.0348v3h16.0348zm-14.5946 1.0805-14.8189-50.8782-2.8803.839 14.8189 50.8782zm-16.2591-51.9587h-.6079v3h.6079zm-2.0484 1.0815-14.7809 50.8782 2.8809.837 14.7809-50.8782zm-13.3404 49.7967h-16.03482v3h16.03482z"
          fill="#000"
          mask="url(#letterW-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterW-b)"
      />
    </svg>
  ),

  letterX: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterX-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterX-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterX-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="77"
        x="2"
        y="-1"
      >
        <path d="m2-1h77v82h-77z" fill="#fff" />
        <path
          d="m24.4462 1.18182 15.6928 26.52198h.608l15.7688-26.52198h18.5806l-23.7482 38.90908 24.2802 38.9091h-18.9226l-15.9588-26.56h-.608l-15.9588 26.56h-18.84657l24.35617-38.9091-23.9002-38.90908z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterX-a)">
        <path
          d="m24.4462 1.18182 15.6928 26.52198h.608l15.7688-26.52198h18.5806l-23.7482 38.90908 24.2802 38.9091h-18.9226l-15.9588-26.56h-.608l-15.9588 26.56h-18.84657l24.35617-38.9091-23.9002-38.90908z"
          fill={getBrandColor()}
        />
        <path
          d="m24.4462 1.18182 1.2909-.763846-.4355-.736158h-.8554zm15.6928 26.52198-1.2909.7639.4356.7361h.8553zm.608 0v1.5h.8532l.4361-.7334zm15.7688-26.52198v-1.500004h-.8533l-.436.733423zm18.5806 0 1.2804.78146 1.3925-2.281464h-2.6729zm-23.7482 38.90908-1.2804-.7815-.4823.7902.4901.7854zm24.2802 38.9091v1.5h2.7041l-1.4316-2.2941zm-18.9226 0-1.2858.7726.4371.7274h.8487zm-15.9588-26.56 1.2857-.7726-.4371-.7274h-.8486zm-.608 0v-1.5h-.8486l-.4371.7274zm-15.9588 26.56v1.5h.8487l.4371-.7274zm-18.84657 0-1.27144-.7959-1.43717 2.2959h2.70861zm24.35617-38.9091 1.2714.7959.4936-.7884-.4869-.7926zm-23.9002-38.90908v-1.500004h-2.68178l1.40365 2.285104zm17.3657.76384 15.6928 26.52204 2.5819-1.5277-15.6929-26.522026zm16.9837 27.25814h.608v-3h-.608zm1.8973-.7334 15.7688-26.52201-2.5786-1.533151-15.7688 26.522061zm14.4795-25.78858h18.5806v-3.000004h-18.5806zm17.3003-2.281471-23.7483 38.909051 2.5607 1.563 23.7483-38.90912zm-23.7405 40.484651 24.2802 38.9091 2.5451-1.5882-24.2802-38.9091zm25.5528 36.615h-18.9226v3h18.9226zm-17.6369.7274-15.9588-26.56-2.5715 1.5451 15.9588 26.5601zm-17.2445-27.2874h-.608v3h.608zm-1.8937.7274-15.9588 26.56 2.5715 1.5452 15.9588-26.5601zm-14.6731 25.8326h-18.84657v3h18.84657zm-17.57513 2.2959 24.35613-38.9091-2.5428-1.5918-24.35621 38.9091zm24.36283-40.4901-23.90017-38.909086-2.55626 1.570206 23.90023 38.90908zm-25.1783-36.62398h18.6566v-3.000004h-18.6566z"
          fill="#000"
          mask="url(#letterX-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterX-b)"
      />
    </svg>
  ),

  letterY: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterY-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterY-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterY-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="80"
        x="0"
        y="-1"
      >
        <path d="m0-1h80v82h-80z" fill="#fff" />
        <path
          d="m3.43723 1.18182h18.42867l17.7446 33.51348h.76l17.7446-33.51348h18.4287l-28.3839 50.30828v27.5099h-16.3388v-27.5099z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterY-a)">
        <path
          d="m3.43723 1.18182h18.42867l17.7446 33.51348h.76l17.7446-33.51348h18.4287l-28.3839 50.30828v27.5099h-16.3388v-27.5099z"
          fill={getBrandColor()}
        />
        <path
          d="m3.43723 1.18182v-1.500004h-2.568568l1.262158 2.237074zm18.42867 0 1.3256-.701904-.4226-.7981h-.903zm17.7446 33.51348-1.3256.7019.4226.7981h.903zm.76 0v1.5h.903l.4226-.7981zm17.7446-33.51348v-1.500004h-.903l-.4226.7981zm18.4287 0 1.3064.73707 1.2621-2.237074h-2.5685zm-28.3839 50.30828-1.3064-.7371-.1936.3431v.394zm0 27.5099v1.5h1.5v-1.5zm-16.3388 0h-1.5v1.5h1.5zm0-27.5099h1.5v-.394l-.1936-.3431zm-28.38387-48.80828h18.42867v-3.000004h-18.42867zm17.10297-.7981 17.7447 33.51348 2.6513-1.4038-17.7447-33.513484zm19.0703 34.31158h.76v-3h-.76zm2.0856-.7981 17.7447-33.51348-2.6513-1.403804-17.7447 33.513484zm16.419-32.71538h18.4287v-3.000004h-18.4287zm17.1223-2.237082-28.3839 50.308262 2.6128 1.4741 28.3839-50.30821zm-28.5775 51.045362v27.5099h3v-27.5099zm1.5 26.0099h-16.3388v3h16.3388zm-14.8388 1.5v-27.5099h-3v27.5099zm-.1936-28.247-28.38385-50.308262-2.61283 1.474152 28.38388 50.30821z"
          fill="#000"
          mask="url(#letterY-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterY-b)"
      />
    </svg>
  ),

  letterZ: ({ classname = '', ...props }) => (
    <svg
      fill="none"
      height="80"
      viewBox="0 0 80 80"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <clipPath id="letterZ-a">
        <path d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z" />
      </clipPath>
      <mask id="letterZ-b" fill="#fff">
        <path
          d="m0 8c0-4.41828 3.58172-8 8-8h64c4.4183 0 8 3.58172 8 8v64c0 4.4183-3.5817 8-8 8h-64c-4.41828 0-8-3.5817-8-8z"
          fill="#fff"
        />
      </mask>
      <mask
        id="letterZ-c"
        fill="#000"
        height="82"
        maskUnits="userSpaceOnUse"
        width="64"
        x="8"
        y="-1"
      >
        <path d="m8-1h64v82h-64z" fill="#fff" />
        <path
          d="m10.2435 79v-9.7653l38.8331-54.4879h-38.9091v-13.56498h59.5795v9.76528l-38.8711 54.4879h38.9471v13.565z"
          fill="#000"
        />
      </mask>
      <g clipPath="url(#letterZ-a)">
        <path
          d="m10.2435 79v-9.7653l38.8331-54.4879h-38.9091v-13.56498h59.5795v9.76528l-38.8711 54.4879h38.9471v13.565z"
          fill={getBrandColor()}
        />
        <path
          d="m10.2435 79h-1.50003v1.5h1.50003zm0-9.7653-1.22155-.8705-.27848.3907v.4798zm38.8331-54.4879 1.2215.8706 1.6895-2.3706h-2.911zm-38.9091 0h-1.50002v1.5h1.50002zm0-13.56498v-1.500004h-1.50002v1.500004zm59.5795 0h1.5v-1.500004h-1.5zm0 9.76528 1.2211.8711.2789-.3909v-.4802zm-38.8711 54.4879-1.2211-.8711-1.6915 2.3711h2.9126zm38.9471 0h1.5v-1.5h-1.5zm0 13.565v1.5h1.5v-1.5zm-58.0795 0v-9.7653h-3.00003v9.7653zm-.2785-8.8947 38.8331-54.4879-2.443-1.7412-38.83315 54.488zm37.6116-56.8585h-38.9091v3h38.9091zm-37.4091 1.5v-13.56498h-3.00002v13.56498zm-1.5-12.06498h59.5795v-3.000004h-59.5795zm58.0795-1.5v9.76528h3v-9.76528zm.2789 8.89418-38.8711 54.4879 2.4422 1.7422 38.8711-54.4879zm-37.65 56.859h38.9471v-3h-38.9471zm37.4471-1.5v13.565h3v-13.565zm1.5 12.065h-59.5795v3h59.5795z"
          fill="#000"
          mask="url(#letterZ-c)"
        />
      </g>
      <path
        d="m8 1.5h64v-3h-64zm70.5 6.5v64h3v-64zm-6.5 70.5h-64v3h64zm-70.5-6.5v-64h-3v64zm6.5 6.5c-3.58985 0-6.5-2.9101-6.5-6.5h-3c0 5.2467 4.2533 9.5 9.5 9.5zm70.5-6.5c0 3.5899-2.9101 6.5-6.5 6.5v3c5.2467 0 9.5-4.2533 9.5-9.5zm-6.5-70.5c3.5899 0 6.5 2.91015 6.5 6.5h3c0-5.24671-4.2533-9.5-9.5-9.5zm-64-3c-5.24671 0-9.5 4.2533-9.5 9.5h3c0-3.58985 2.91015-6.5 6.5-6.5z"
        fill="#000"
        mask="url(#letterZ-b)"
      />
    </svg>
  ),
};

export default LetterIcons;
